import React, {useRef, useEffect, useState, useMemo} from 'react';
import {useQuery} from 'react-query';
import {Card} from 'react-bootstrap';
import * as moment from 'moment';
import $ from 'jquery';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import SmallBox from '../components/small-box/SmallBox';
import {
    POST_API,
    ACCOUNT_API,
    WEB_ANALYSIS,
    LOG_API,
    LOGIN_HISTORY_API,
    ADVERTISING_ANALYSIS_API,
    BAOCAO_API,
} from '../utils/apiUrl.js';
import {Get} from '../utils/httpProvider';
// import ListPost from './post/ListPost';
import {
    postStatus,
    reportPost,
    objectStatusPost,
    rangeDate,
    rangeDateReport,
    styleSelectDefault,
    rangeDateDashboardNotHaveDate
} from '../utils/define';
import {getDateTimeISOString, dateTimeToStringRequest} from '../utils/helper';
import {AsyncPaginate} from 'react-select-async-paginate';
import Plotly from 'plotly.js-basic-dist';
import createPlotlyComponent from 'react-plotly.js/factory';
import locale from 'plotly.js-locales/vi';
const Plot = createPlotlyComponent(Plotly);
Plotly.register(locale);
Plotly.setPlotConfig({locale: 'vi'});

const Dashboard = () => {
    const refBaocao = useRef(null);
    const [activeTab, setActiveTab] = useState(postStatus.all);
    const [chieucao, setChieucao] = useState(0);
    const [accountHisId, setAccountHisId] = useState('');
    // const [displayBy, setDisplayBy] = useState('date');
    const [displayBy, setDisplayBy] = useState('week');
    const [displayByCancel, setDisplayByCancel] = useState('week');
    const [displayByBaoHiem, setDisplayByBaoHiem] = useState('week');
    const [displayByMethod, setDisplayByMethod] = useState('week');
    const [displayBySoTienVaDonVi, setDisplayBySoTienVaDonVi] =
        useState('week');
    const [displayByHMSFeeTraLai, setDisplayByHMSFeeTraLai] =
        useState('week');

    const combineAndAggregateData = (phanMemData, duLieuBenhVienData, key) => {
        const aggregated = {};

        // Combine and aggregate data
        [...phanMemData, ...duLieuBenhVienData].forEach((item) => {
            const name = item[key];
            if (!aggregated[name]) {
                aggregated[name] = 0;
            }
            aggregated[name] += item.tanSuat;
        });

        return aggregated;
    };

    const sanitizeHtml = (htmlString) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText || ''; // Extract text content
    };

    const formatNumber = (num) => {
        if (Math.abs(num) >= 1.0e9) {
            return (num / 1.0e9).toFixed(1) + 'B'; // Billion
        } else if (Math.abs(num) >= 1.0e6) {
            return (num / 1.0e6).toFixed(1) + 'M'; // Million
        } else if (Math.abs(num) >= 1.0e3) {
            return (num / 1.0e3).toFixed(1) + 'K'; // Thousand
        } else {
            return num.toFixed(1); // Original number
        }
    };

    const [monthNames, setMonthNames] = useState([
        'Tháng 1',
        'Tháng 2',
        'Tháng 3',
        'Tháng 4',
        'Tháng 5',
        'Tháng 6',
        'Tháng 7',
        'Tháng 8',
        'Tháng 9',
        'Tháng 10',
        'Tháng 11',
        'Tháng 12'
    ]);

    const timeCurentDay = moment().subtract(3, 'months');
    timeCurentDay.set({hour: 0, minute: 0, second: 0, millisecond: 0});

    const [datesMethodDonut, setDatesMethodDonut] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    const [datesMethodLine, setDatesMethodLine] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    const [datesMethodLineSoLuongDeNghi, setDatesMethodLineSoLuongDeNghi] =
        useState({
            startDate: timeCurentDay,
            endDate: moment()
        });

    const [datesMethodLineCancel, setDatesMethodLineCancel] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    const [datesLineBaoHiem, setDatesLineBaoHiem] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    const [datesGiamSat, setDatesGiamSat] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    const [datesSoTienVaDonVi, setDatesSoTienVaDonVi] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    const [datesNoiDungDonViTanSuat, setDatesNoiDungDonViTanSuat] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    const [datesHMSFeeTraLai, setDatesHMSFeeTraLai] = useState({
        startDate: timeCurentDay,
        endDate: moment()
    });

    // const listAccountHis = useQuery(['getAllAccountHis'], () =>
    //     Get(ACCOUNTHIS_API.GET_PAGING, null, {
    //         PageIndex: 1,
    //         PageSize: 10000,
    //         Keyword: ''
    //     })
    // );

    // Account His
    // const lstAccountHis =
    //     listAccountHis && listAccountHis.data && listAccountHis.data.data
    //         ? listAccountHis.data.data.map((x) => ({
    //               label: x.username,
    //               value: x.id
    //           }))
    //         : [];

    // Thống kê số lượng method
    const lstCountReportDonut = useQuery(['lstCountReportDonutData'], () => {
        let model = {};

        if (datesMethodDonut && datesMethodDonut.startDate) {
            model.ThoiGianBaoCaoBatDau =
                datesMethodDonut.startDate._d.toISOString();
        }

        if (datesMethodDonut && datesMethodDonut.endDate) {
            model.ThoiGianBaoCaoKetThuc =
                datesMethodDonut.endDate._d.toISOString();
        }

        return Get(BAOCAO_API.GET_BAOCAO_SOLUONG_DONUT, null, model);
    });

    // Thống kê số lượng method
    const lstCountMethodLine = useQuery(['lstCountMethodLineData'], () => {
        let model = {};

        if (datesMethodLine && datesMethodLine.startDate) {
            model.ThoiGianBaoCaoBatDau =
                datesMethodLine.startDate._d.toISOString();
        }

        if (datesMethodLine && datesMethodLine.endDate) {
            model.ThoiGianBaoCaoKetThuc =
                datesMethodLine.endDate._d.toISOString();
        }

        return Get(BAOCAO_API.GET_BAOCAO_SOLUONG_LINE, null, model);
    });

    const lstCountCancelMethodLine = useQuery(
        ['lstCountCancelMethodLineData'],
        () => {
            let model = {};

            if (datesMethodLineCancel && datesMethodLineCancel.startDate) {
                model.ThoiGianBaoCaoBatDau =
                    datesMethodLineCancel.startDate._d.toISOString();
            }

            if (datesMethodLineCancel && datesMethodLineCancel.endDate) {
                model.ThoiGianBaoCaoKetThuc =
                    datesMethodLineCancel.endDate._d.toISOString();
            }

            return Get(BAOCAO_API.GET_BAOCAO_SOLUONG_CANCEL_LINE, null, model);
        }
    );

    const lstCountBaoHiemLine = useQuery(['lstCountBaoHiemLineData'], () => {
        let model = {};

        if (datesLineBaoHiem && datesLineBaoHiem.startDate) {
            model.StartDate = datesLineBaoHiem.startDate._d.toISOString();
        }

        if (datesLineBaoHiem && datesLineBaoHiem.endDate) {
            model.EndDate = datesLineBaoHiem.endDate._d.toISOString();
        }

        return Get(BAOCAO_API.GET_BAOCAO_CHINHSUABAOHIEM_LINE, null, model);
    });

    // Thống kê số lượng method
    const lstCountSLDNPMMethodLine = useQuery(
        ['lstCountSLDNPMMethodLineData'],
        () => {
            let model = {};

            if (
                datesMethodLineSoLuongDeNghi &&
                datesMethodLineSoLuongDeNghi.startDate
            ) {
                model.NgayDeNghi =
                    datesMethodLineSoLuongDeNghi.startDate._d.toISOString();
            }

            if (
                datesMethodLineSoLuongDeNghi &&
                datesMethodLineSoLuongDeNghi.endDate
            ) {
                model.NgayHoanThanh =
                    datesMethodLineSoLuongDeNghi.endDate._d.toISOString();
            }

            return Get(BAOCAO_API.GET_BAOCAO_PHANMEM_SLDN, null, model);
        }
    );

    // Thống kê số lượng method
    const lstCountSLDNDLBVMethodLine = useQuery(
        ['lstCountSLDNDLBVMethodLineData'],
        () => {
            let model = {};

            if (
                datesMethodLineSoLuongDeNghi &&
                datesMethodLineSoLuongDeNghi.startDate
            ) {
                model.NgayDeNghi =
                    datesMethodLineSoLuongDeNghi.startDate._d.toISOString();
            }

            if (
                datesMethodLineSoLuongDeNghi &&
                datesMethodLineSoLuongDeNghi.endDate
            ) {
                model.NgayHoanThanh =
                    datesMethodLineSoLuongDeNghi.endDate._d.toISOString();
            }

            return Get(BAOCAO_API.GET_BAOCAO_DULIEUBENHVIEN_SLDN, null, model);
        }
    );

    // Noi Dung Ly Do Bar Graph

    const lstGiamSatChinhSuaPhanMemNoiDungPhoBien = useQuery(
        ['lstGiamSatChinhSuaPhanMemNoiDungPhoBienData'],
        () => {
            let model = {};

            if (datesGiamSat && datesGiamSat.startDate) {
                model.NgayDeNghi = datesGiamSat.startDate._d.toISOString();
            }

            if (datesGiamSat && datesGiamSat.endDate) {
                model.NgayHoanThanh = datesGiamSat.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_PHANMEM_NOIDUNG_THUONGGAP,
                null,
                model
            );
        }
    );

    const lstGiamSatChinhSuaPhanMemLyDoPhoBien = useQuery(
        ['lstGiamSatChinhSuaPhanMemLyDoPhoBienData'],
        () => {
            let model = {};

            if (datesGiamSat && datesGiamSat.startDate) {
                model.NgayDeNghi = datesGiamSat.startDate._d.toISOString();
            }

            if (datesGiamSat && datesGiamSat.endDate) {
                model.NgayHoanThanh = datesGiamSat.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_PHANMEM_LYDO_THUONGGAP,
                null,
                model
            );
        }
    );

    const lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBien = useQuery(
        ['lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienData'],
        () => {
            let model = {};

            if (datesGiamSat && datesGiamSat.startDate) {
                model.NgayDeNghi = datesGiamSat.startDate._d.toISOString();
            }

            if (datesGiamSat && datesGiamSat.endDate) {
                model.NgayHoanThanh = datesGiamSat.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_DULIEUBENHVIEN_NOIDUNG_PHOBIEN,
                null,
                model
            );
        }
    );

    const lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBien = useQuery(
        ['lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBienData'],
        () => {
            let model = {};

            if (datesGiamSat && datesGiamSat.startDate) {
                model.NgayDeNghi = datesGiamSat.startDate._d.toISOString();
            }

            if (datesGiamSat && datesGiamSat.endDate) {
                model.NgayHoanThanh = datesGiamSat.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_DULIEUBENHVIEN_LYDO_PHOBIEN,
                null,
                model
            );
        }
    );

    // Noi Dung Ly Do Donut
    const lstGiamSatChinhSuaPhanMemNoiDungPhoBienDonut = useQuery(
        ['lstGiamSatChinhSuaPhanMemNoiDungPhoBienDonutData'],
        () => {
            let model = {};

            if (datesMethodDonut && datesMethodDonut.startDate) {
                model.NgayDeNghi = datesMethodDonut.startDate._d.toISOString();
            }

            if (datesMethodDonut && datesMethodDonut.endDate) {
                model.NgayHoanThanh = datesMethodDonut.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_PHANMEM_NOIDUNG_THUONGGAP,
                null,
                model
            );
        }
    );

    const lstGiamSatChinhSuaPhanMemLyDoPhoBienDonut = useQuery(
        ['lstGiamSatChinhSuaPhanMemLyDoPhoBienDonutData'],
        () => {
            let model = {};

            if (datesMethodDonut && datesMethodDonut.startDate) {
                model.NgayDeNghi = datesMethodDonut.startDate._d.toISOString();
            }

            if (datesMethodDonut && datesMethodDonut.endDate) {
                model.NgayHoanThanh = datesMethodDonut.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_PHANMEM_LYDO_THUONGGAP,
                null,
                model
            );
        }
    );

    const lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienDonut = useQuery(
        ['lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienDonutData'],
        () => {
            let model = {};

            if (datesMethodDonut && datesMethodDonut.startDate) {
                model.NgayDeNghi = datesMethodDonut.startDate._d.toISOString();
            }

            if (datesMethodDonut && datesMethodDonut.endDate) {
                model.NgayHoanThanh = datesMethodDonut.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_DULIEUBENHVIEN_NOIDUNG_PHOBIEN,
                null,
                model
            );
        }
    );

    const lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBienDonut = useQuery(
        ['lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBienDonutData'],
        () => {
            let model = {};

            if (datesMethodDonut && datesMethodDonut.startDate) {
                model.NgayDeNghi = datesMethodDonut.startDate._d.toISOString();
            }

            if (datesMethodDonut && datesMethodDonut.endDate) {
                model.NgayHoanThanh = datesMethodDonut.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_DULIEUBENHVIEN_LYDO_PHOBIEN,
                null,
                model
            );
        }
    );

    // test

    const lstNoiDungDonViTanSuatScatter = useQuery(
        ['lstNoiDungDonViTanSuatScatter'],
        () => {
            let model = {};

            if (
                datesNoiDungDonViTanSuat &&
                datesNoiDungDonViTanSuat.startDate
            ) {
                model.NgayDeNghi =
                    datesNoiDungDonViTanSuat.startDate._d.toISOString();
            }

            if (datesNoiDungDonViTanSuat && datesNoiDungDonViTanSuat.endDate) {
                model.NgayHoanThanh =
                    datesNoiDungDonViTanSuat.endDate._d.toISOString();
            }

            return Get(
                BAOCAO_API.GET_BAOCAO_NOIDUNG_DONVI_TANSUAT,
                null,
                model
            );
        }
    );

    // Số tiền và đơn vị
    const lstSoTienChenhLechBar = useQuery(
        ['lstSoTienChenhLechBarData'],
        () => {
            let model = {};

            if (datesSoTienVaDonVi && datesSoTienVaDonVi.startDate) {
                model.NgayDeNghi =
                    datesSoTienVaDonVi.startDate._d.toISOString();
            }

            if (datesSoTienVaDonVi && datesSoTienVaDonVi.endDate) {
                model.NgayHoanThanh =
                    datesSoTienVaDonVi.endDate._d.toISOString();
            }

            return Get(BAOCAO_API.GET_BAOCAO_SOTIENCHENHLECH_DLBV, null, model);
        }
    );

    const lstDonViTanSuatBar = useQuery(['lstDonViTanSuatBarData'], () => {
        let model = {};

        if (datesSoTienVaDonVi && datesSoTienVaDonVi.startDate) {
            model.NgayDeNghi = datesSoTienVaDonVi.startDate._d.toISOString();
        }

        if (datesSoTienVaDonVi && datesSoTienVaDonVi.endDate) {
            model.NgayHoanThanh = datesSoTienVaDonVi.endDate._d.toISOString();
        }

        return Get(BAOCAO_API.GET_BAOCAO_DONVIDENGHI_TANSUAT, null, model);
    });

    // HMS Fee Status R

    const lstCountHMSFeeTraLai = useQuery(
        ['lstCountHMSFeeTraLaiData'],
        () => {
            let model = {};

            if (datesHMSFeeTraLai && datesHMSFeeTraLai.startDate) {
                model.ThoiGianBaoCaoBatDau =
                    datesHMSFeeTraLai.startDate._d.toISOString();
            }

            if (datesHMSFeeTraLai && datesHMSFeeTraLai.endDate) {
                model.ThoiGianBaoCaoKetThuc =
                    datesHMSFeeTraLai.endDate._d.toISOString();
            }

            return Get(BAOCAO_API.GET_BAOCAO_SOLUONG_TRALAI, null, model);
        }
    );

    // Số lượng báo cáo
    const countReport = useQuery(['countReportData'], () => {
        return Get(BAOCAO_API.GET_BAOCAO_SOLUONG, null, {
            AccountHisId:
                accountHisId && accountHisId.target && accountHisId.target.value
                    ? accountHisId.target.value.value
                    : ''
        });
    });

    const countCancelReport = useQuery(['countReportCancelData'], () => {
        return Get(BAOCAO_API.GET_BAOCAO_SOLUONG_CANCEL, null, {});
    });

    const countTraLaiReport = useQuery(['countTraLaiReportData'], () => {
        return Get(BAOCAO_API.GET_BAOCAO_THONGKE_TRALAI, null, {});
    });

    useEffect(() => {
        lstCountReportDonut.refetch();
    }, [datesMethodDonut]);

    useEffect(() => {
        lstCountMethodLine.refetch();
    }, [datesMethodLine, datesMethodLineSoLuongDeNghi]);

    useEffect(() => {
        lstCountSLDNPMMethodLine.refetch();
        lstCountSLDNDLBVMethodLine.refetch();
    }, [datesMethodLineSoLuongDeNghi]);

    useEffect(() => {
        lstCountCancelMethodLine.refetch();
    }, [datesMethodLineCancel]);

    useEffect(() => {
        lstCountBaoHiemLine.refetch();
    }, [datesLineBaoHiem]);

    useEffect(() => {
        lstGiamSatChinhSuaPhanMemNoiDungPhoBien.refetch();
        lstGiamSatChinhSuaPhanMemLyDoPhoBien.refetch();
        lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBien.refetch();
        lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBien.refetch();
    }, [datesGiamSat]);

    useEffect(() => {
        lstGiamSatChinhSuaPhanMemNoiDungPhoBienDonut.refetch();
        lstGiamSatChinhSuaPhanMemLyDoPhoBienDonut.refetch();
        lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienDonut.refetch();
        lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBienDonut.refetch();
    }, [datesMethodDonut]);

    useEffect(() => {
        lstSoTienChenhLechBar.refetch();
        lstDonViTanSuatBar.refetch();
    }, [datesSoTienVaDonVi]);

    useEffect(() => {
        lstCountHMSFeeTraLai.refetch();
    }, [datesHMSFeeTraLai]);

    useEffect(() => {
        countReport.refetch();
    }, [accountHisId]);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    useEffect(() => {
        setChieucao(refBaocao.current.clientHeight);
    });

    const resizeWindow = () => {
        setChieucao(refBaocao.current.clientHeight);
    };

    useEffect(() => {
        window.addEventListener('resize', resizeWindow);
        return () => window.removeEventListener('resize', resizeWindow);
    }, []);

    // var DATA_COUNT = 10;
    // var labels = [];

    // Utils.srand(4);

    // for (var i = 0; i < DATA_COUNT; ++i) {
    //     labels.push('' + i);
    // }

    // const optionV1 = {
    //     plugins: {
    //         datalabels: {
    //             backgroundColor: function (context) {
    //                 return context.dataset.backgroundColor;
    //             },
    //             borderColor: 'white',
    //             borderRadius: 25,
    //             borderWidth: 2,
    //             color: 'white',
    //             display: function (context) {
    //                 var dataset = context.dataset;
    //                 var count = dataset.data.length;
    //                 var value = dataset.data[context.dataIndex];
    //                 return value > count * 1.5;
    //             },
    //             font: {
    //                 weight: 'bold'
    //             },
    //             padding: 6,
    //             formatter: Math.round
    //         }
    //     },

    //     // Core options
    //     aspectRatio: 4 / 3,
    //     cutoutPercentage: 32,
    //     layout: {
    //         padding: 32
    //     },
    //     elements: {
    //         line: {
    //             fill: false
    //         },
    //         point: {
    //             hoverRadius: 7,
    //             radius: 5
    //         }
    //     }
    // };

    // const dataV1 = {
    //     labels: labels,
    //     datasets: [
    //         {
    //             backgroundColor: Utils.colors({
    //                 color: Utils.color(0),
    //                 count: DATA_COUNT
    //             }),
    //             data: Utils.numbers({
    //                 count: DATA_COUNT,
    //                 min: 0,
    //                 max: 100
    //             }),
    //             datalabels: {
    //                 anchor: 'end'
    //             }
    //         },
    //         {
    //             backgroundColor: Utils.colors({
    //                 color: Utils.color(1),
    //                 count: DATA_COUNT
    //             }),
    //             data: Utils.numbers({
    //                 count: DATA_COUNT,
    //                 min: 0,
    //                 max: 100
    //             }),
    //             datalabels: {
    //                 anchor: 'center',
    //                 backgroundColor: null,
    //                 borderWidth: 0
    //             }
    //         },
    //         {
    //             backgroundColor: Utils.colors({
    //                 color: Utils.color(2),
    //                 count: DATA_COUNT
    //             }),
    //             data: Utils.numbers({
    //                 count: DATA_COUNT,
    //                 min: 0,
    //                 max: 100
    //             }),
    //             datalabels: {
    //                 anchor: 'start'
    //             }
    //         }
    //     ]
    // };
    // var dataV2 = {
    //     values: [16, 15, 12, 6, 5, 4, 42],
    //     labels: [
    //         'US',
    //         'China',
    //         'European Union',
    //         'Russian Federation',
    //         'Brazil',
    //         'India',
    //         'Rest of World'
    //     ],
    //     domain: {column: 0},
    //     name: 'GHG Emissions',
    //     hoverinfo: 'label+percent+name',
    //     hole: 0.4,
    //     type: 'pie'
    // };
    // var layout = {
    //     title: 'Global Emissions 1990-2011',
    //     annotations: [
    //         {
    //             font: {
    //                 size: 20
    //             },
    //             showarrow: false,
    //             text: 'GHG',
    //             x: 0.17,
    //             y: 0.5
    //         },
    //         {
    //             font: {
    //                 size: 20
    //             },
    //             showarrow: false,
    //             text: 'CO2',
    //             x: 0.82,
    //             y: 0.5
    //         }
    //     ],
    //     height: 400,
    //     width: 600,
    //     showlegend: false,
    //     grid: {rows: 1, columns: 2}
    // };

    // const plotRef = useRef(null);
    // const [isPlotRendered, setIsPlotRendered] = useState(false);

    // useEffect(() => {
    //     if (plotRef.current && !isPlotRendered) {
    //         const dataV2 = {
    //             values: [16, 15, 12, 6, 5, 4, 42],
    //             labels: [
    //                 'US',
    //                 'China',
    //                 'European Union',
    //                 'Russian Federation',
    //                 'Brazil',
    //                 'India',
    //                 'Rest of World'
    //             ],
    //             domain: { column: 0 },
    //             name: 'GHG Emissions',
    //             hoverinfo: 'label+percent+name',
    //             hole: 0.4,
    //             type: 'pie'
    //         };
    //         const layout = {
    //             title: 'Global Emissions 1990-2011',
    //             annotations: [
    //                 {
    //                     font: {
    //                         size: 20
    //                     },
    //                     showarrow: false,
    //                     text: 'GHG',
    //                     x: 0.19,
    //                     y: 0.5
    //                 },
    //                 // {
    //                 //     font: {
    //                 //         size: 20
    //                 //     },
    //                 //     showarrow: false,
    //                 //     text: 'CO2',
    //                 //     x: 0.82,
    //                 //     y: 0.5
    //                 // }
    //             ],
    //             height: "100%",
    //             width: "100%",
    //             showlegend: false,
    //             grid: { rows: 1, columns: 2 }
    //         };

    //         Plotly.newPlot(plotRef.current, [dataV2], layout);
    //         setIsPlotRendered(true);
    //     }
    // }, [isPlotRendered]);

    // Compute percentages using useMemo for performance optimization
    // const percentages = useMemo(() => {
    //     const total = (lstCountReportDonut?.data?.totalUpdate ?? 0) + (lstCountReportDonut?.data?.totalDelete ?? 0);
    //     const updatePercent = total > 0 ? ((lstCountReportDonut.data.totalUpdate / total) * 100).toFixed(2) : 0;
    //     const deletePercent = total > 0 ? ((lstCountReportDonut.data.totalDelete / total) * 100).toFixed(2) : 0;
    //     return { updatePercent, deletePercent };
    // }, [lstCountReportDonut]);

    // const plotRef = useRef(null);
    // const [isPlotRendered, setIsPlotRendered] = useState(false);

    // useEffect(() => {
    //     if (plotRef.current && !isPlotRendered) {
    //         const dataV2 = {
    //             values: [
    //                 lstCountReportDonut?.data?.totalUpdate ?? 0,
    //                 lstCountReportDonut?.data?.totalDelete ?? 0
    //             ],
    //             labels: ['Update', 'Delete'],
    //             domain: {column: 0},
    //             name: 'Tỉ lệ Method',
    //             hoverinfo: 'label+percent+name',
    //             hole: 0.4,
    //             type: 'pie',
    //             textinfo: 'label+percent',
    //             textfont: {
    //                 color: 'white', // Set the percentage text color to white
    //                 size: 12 // Adjust the size of the text
    //             },
    //             hoverlabel: {
    //                 font: {
    //                     color: 'white' // Make hover text white
    //                 }
    //                 // bgcolor: '#333333' // Dark background for better contrast
    //             }
    //         };

    //         const layout = {
    //             title: 'Tỉ lệ method',
    //             annotations: [
    //                 {
    //                     font: {
    //                         size: 20
    //                     },
    //                     showarrow: false,
    //                     text: 'Method',
    //                     x: 0.5,
    //                     y: 0.5
    //                 }
    //                 // {
    //                 //     font: {
    //                 //         size: 20
    //                 //     },
    //                 //     showarrow: false,
    //                 //     text: 'CO2',
    //                 //     x: 0.82,
    //                 //     y: 0.5
    //                 // }
    //             ],
    //             autosize: true, // Makes the chart automatically resize
    //             responsive: true, // Ensures responsiveness
    //             // height: "100%", // Removes fixed height
    //             // width: "100%", // Removes fixed width
    //             showlegend: true,
    //             legend: {
    //                 font: {
    //                     color: 'black' // Set legend text to white
    //                 }
    //             },
    //             transition: {
    //                 duration: 500, // Animation duration in milliseconds
    //                 easing: 'cubic-in-out' // Type of easing function
    //             },
    //             grid: {rows: 0, columns: 0}
    //         };

    //         const config = {responsive: true}; // Responsive config for Plotly

    //         Plotly.newPlot(plotRef.current, [dataV2], layout, config);
    //         setIsPlotRendered(true);

    //         // Ensure the plot resizes on window resize
    //         window.addEventListener('resize', () => {
    //             Plotly.Plots.resize(plotRef.current);
    //         });
    //     }
    // }, [isPlotRendered, lstCountReportDonut]);

    // test

    const plotRefTest = useRef(null);

    useEffect(() => {
        if (
            plotRefTest.current &&
            lstNoiDungDonViTanSuatScatter &&
            lstNoiDungDonViTanSuatScatter.data
        ) {
            const data = lstNoiDungDonViTanSuatScatter.data.map((x) => ({
                NoiDungChinhSua: sanitizeHtml(x.noiDung), // Correctly map 'noiDung' to 'NoiDungChinhSua'
                TanSuat: x.tanSuat, // Map 'TanSuat'
                Cluster: x.donVi // Map 'DonVi' to 'Cluster'
            }));

            // Map NoiDungChinhSua to numeric indices for the Y-axis
            const categories = [
                ...new Set(data.map((item) => item.NoiDungChinhSua))
            ];
            const categoryMapping = categories.reduce(
                (acc, category, index) => ({...acc, [category]: index + 1}),
                {}
            );

            // Group data by clusters
            const clusters = [...new Set(data.map((item) => item.Cluster))];
            const traces = clusters.map((cluster) => {
                const clusterData = data.filter(
                    (item) => item.Cluster === cluster
                );
                return {
                    x: clusterData.map((item) => item.TanSuat), // X-axis is TanSuat
                    y: clusterData.map(
                        (item) => categoryMapping[item.NoiDungChinhSua]
                    ), // Y-axis is NoiDungChinhSua (mapped to numbers)
                    mode: 'markers',
                    type: 'scatter',
                    name: cluster,
                    marker: {size: 10}
                };
            });

            const layout = {
                title: 'Scatter Plot with Categorical NoiDungChinhSua',
                xaxis: {title: 'Tần Suất'},
                yaxis: {
                    title: 'Nội Dung Chỉnh Sửa',
                    tickvals: Object.values(categoryMapping),
                    ticktext: Object.keys(categoryMapping) // Display original string values as ticks
                },
                showlegend: true
            };

            const config = {responsive: true};

            Plotly.newPlot(plotRefTest.current, traces, layout, config);
        }
    }, [lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienDonut?.data]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefTest.current) {
                Plotly.Plots.resize(plotRefTest.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefTest.current) {
                Plotly.purge(plotRefTest.current);
            }
        };
    }, []);

    // end test

    const plotRef = useRef(null);
    const plotRefNoiDungDonut = useRef(null);
    const plotRefLyDoDonut = useRef(null);

    const isMobile = () => {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    };

    useEffect(() => {
        if (
            plotRef.current &&
            lstCountReportDonut &&
            lstCountReportDonut.data &&
            lstGiamSatChinhSuaPhanMemNoiDungPhoBienDonut &&
            lstGiamSatChinhSuaPhanMemNoiDungPhoBienDonut.data &&
            lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienDonut &&
            lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienDonut.data &&
            lstGiamSatChinhSuaPhanMemLyDoPhoBienDonut &&
            lstGiamSatChinhSuaPhanMemLyDoPhoBienDonut.data &&
            lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBienDonut &&
            lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBienDonut.data
        ) {
            // if (
            //     lstCountReportDonut.data?.totalUpdate == 0 &&
            //     lstCountReportDonut.data?.totalDelete == 0
            // ) {
            //     return;
            // }

            const fixedDonutHeight = 400; // Fixed donut chart height
            const legendItemHeight = 20; // Approximate height per legend item
            const baseLegendHeight = 40; // Base legend height (padding, margins, etc.)

            // Calculate legend heights dynamically based on the number of items
            const calculateLegendHeight = (itemsCount) =>
                baseLegendHeight + itemsCount * legendItemHeight;

            // Calculate the number of items for each chart
            const reportItemsCount = 1; // Fixed number of items for the report chart

            const noiDungAggregated = combineAndAggregateData(
                lstGiamSatChinhSuaPhanMemNoiDungPhoBienDonut.data,
                lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienDonut.data,
                'noiDung'
            );

            const lyDoAggregated = combineAndAggregateData(
                lstGiamSatChinhSuaPhanMemLyDoPhoBienDonut.data,
                lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBienDonut.data,
                'lyDo'
            );

            const noiDungItemsCount = Object.keys(noiDungAggregated).length;
            const lyDoItemsCount = Object.keys(lyDoAggregated).length;

            // Calculate the total layout height for each chart
            const reportLegendHeight = calculateLegendHeight(reportItemsCount);
            const noiDungLegendHeight =
                calculateLegendHeight(noiDungItemsCount);
            const lyDoLegendHeight = calculateLegendHeight(lyDoItemsCount);

            const totalReportHeight = fixedDonutHeight + reportLegendHeight;
            const totalNoiDungHeight = fixedDonutHeight + noiDungLegendHeight;
            const totalLyDoHeight = fixedDonutHeight + lyDoLegendHeight;

            // const uniformDonutHeight = Math.min(
            //     calculateDonutHeight(noiDungItemsCount),
            //     calculateDonutHeight(lyDoItemsCount),
            //     calculateDonutHeight(reportItemsCount)
            // );

            const dataV2 = {
                values: [
                    lstCountReportDonut.data?.totalUpdate ?? 0,
                    lstCountReportDonut.data?.totalDelete ?? 0,
                    lstCountReportDonut.data?.totalCancel ?? 0
                ],
                labels: ['Cập nhật', 'Xoá', 'Huỷ'],
                name: 'Tỉ lệ<br>Chức năng',
                hoverinfo: 'label+percent+name',
                hole: 0.4,
                type: 'pie',
                textinfo: 'percent', // Display percentages on the chart
                textfont: {
                    color: 'white',
                    size: 12
                },
                hoverlabel: {
                    font: {
                        color: 'white'
                    }
                }
            };

            let sharedLayout = {};

            if (isMobile()) {
                sharedLayout = {
                    autosize: true,
                    showlegend: true,
                    legend: {
                        orientation: 'h',
                        font: {
                            size: 10, // Smaller font size for mobile
                            color: 'black'
                        },
                        x: 0.5,
                        xanchor: 'center',
                        y: -0.1 // Adjust legend position below the chart
                    },
                    pie: {
                        domain: {
                            x: [0, 1], // Full width for the donut
                            y: [0.2, 1] // Allocate 80% height for the chart
                        }
                    },
                    annotations: [
                        {
                            font: {size: 20},
                            showarrow: false,
                            text: '',
                            x: 0.5,
                            y: 0.5
                        }
                    ],
                    margin: {
                        t: 50, // Reduce top margin to bring the chart closer to the title
                        b: 40, // Bottom margin for the legend
                        l: 10, // Left margin
                        r: 10 // Right margin
                    }
                };
            } else {
                sharedLayout = {
                    autosize: false,
                    showlegend: true,
                    width: 500,
                    legend: {
                        orientation: 'h',
                        x: 0.5,
                        fontSize: 12,
                        xanchor: 'center',
                        y: -0.3 // Adjust legend position below the chart
                    },
                    pie: {
                        domain: {
                            x: [0, 1], // Full width for the donut
                            y: [
                                0,
                                fixedDonutHeight /
                                    (fixedDonutHeight +
                                        calculateLegendHeight(3))
                            ] // Proportional allocation for the donut
                        }
                    },
                    annotations: [
                        {
                            font: {size: 20},
                            showarrow: false,
                            text: '',
                            x: 0.5,
                            y: 0.5
                        }
                    ]
                };
            }

            const layout = {
                ...sharedLayout,
                title: 'Tỉ lệ Chức năng',
                height: totalReportHeight,
                annotations: [
                    {
                        ...sharedLayout.annotations[0],
                        text: 'Chức<br>năng'
                    }
                ]
            };

            const dataNoiDung = {
                values: Object.values(noiDungAggregated),
                labels: Object.keys(noiDungAggregated).map(sanitizeHtml),
                name: 'Tỉ lệ<br>Nội dung chỉnh sửa',
                hoverinfo: 'label+percent+name',
                hole: 0.4,
                type: 'pie',
                textinfo: 'percent', // Display percentages on the chart
                textfont: {
                    color: 'white',
                    size: 12
                },
                hoverlabel: {
                    font: {
                        color: 'white'
                    }
                }
            };

            // const layoutNoiDung = {
            //     title: 'Tỉ lệ Nội dung chỉnh sửa',
            //     annotations: [
            //         {
            //             font: {size: 20},
            //             showarrow: false,
            //             text: 'Nội<br>dung',
            //             x: 0.5,
            //             y: 0.5
            //         }
            //     ],
            //     autosize: true,
            //     responsive: true,
            //     showlegend: true,
            //     legend: {
            //         font: {color: 'black'}
            //     },
            //     transition: {
            //         duration: 500,
            //         easing: 'cubic-in-out'
            //     },
            //     grid: {rows: 0, columns: 0}
            // };

            const layoutNoiDung = {
                ...sharedLayout,
                title: 'Tỉ lệ Nội dung chỉnh sửa',
                height: totalNoiDungHeight,
                annotations: [
                    {
                        ...sharedLayout.annotations[0],
                        text: 'Nội<br>dung'
                    }
                ]
            };

            const dataLyDo = {
                values: Object.values(lyDoAggregated),
                labels: Object.keys(lyDoAggregated).map(sanitizeHtml),
                name: 'Tỉ lệ<br>Lý do chỉnh sửa',
                hoverinfo: 'label+percent+name',
                hole: 0.4,
                type: 'pie',
                textinfo: 'percent', // Display percentages on the chart
                textfont: {
                    color: 'white',
                    size: 12
                },
                hoverlabel: {
                    font: {
                        color: 'white'
                    }
                }
            };

            const layoutLyDo = {
                ...sharedLayout,
                title: 'Tỉ lệ Lý do chỉnh sửa',
                height: totalLyDoHeight,
                annotations: [
                    {
                        ...sharedLayout.annotations[0],
                        text: 'Lý<br>do'
                    }
                ]
            };

            const config = {responsive: true};

            // Render the plot
            Plotly.newPlot(plotRef.current, [dataV2], layout, config);
            Plotly.newPlot(
                plotRefNoiDungDonut.current,
                [dataNoiDung],
                layoutNoiDung,
                config
            );
            Plotly.newPlot(
                plotRefLyDoDonut.current,
                [dataLyDo],
                layoutLyDo,
                config
            );

            // // Handle window resize
            // const handleResize = () => {
            //     Plotly.Plots.resize(plotRef.current);
            // };

            // window.addEventListener('resize', handleResize);

            // // Cleanup on unmount
            // return () => {
            //     window.removeEventListener('resize', handleResize);
            //     Plotly.purge(plotRef.current); // Optional: Clean up Plotly graph
            // };
        } else {
            const config = {responsive: true};
            // Render the plot
            Plotly.newPlot(
                plotRef.current,
                [{type: 'pie'}],
                {
                    title: 'Tỉ lệ Chức năng',
                    height: 500,
                    annotations: [
                        {
                            font: {size: 20},
                            showarrow: false,
                            x: 0.5,
                            y: 0.5,
                            text: 'Chức<br>năng'
                        }
                    ]
                },
                config
            );
            Plotly.newPlot(
                plotRefNoiDungDonut.current,
                [{type: 'pie'}],
                {
                    title: 'Tỉ lệ Nội dung chỉnh sửa',
                    height: 500,
                    annotations: [
                        {
                            font: {size: 20},
                            showarrow: false,
                            x: 0.5,
                            y: 0.5,
                            text: 'Nội<br>dung'
                        }
                    ]
                },
                config
            );
            Plotly.newPlot(
                plotRefLyDoDonut.current,
                [{type: 'pie'}],
                {
                    title: 'Tỉ lệ Lý do chỉnh sửa',
                    height: 500,
                    annotations: [
                        {
                            font: {size: 20},
                            showarrow: false,
                            x: 0.5,
                            y: 0.5,
                            text: 'Lý<br>do'
                        }
                    ]
                },
                config
            );
        }
    }, [
        lstCountReportDonut.data,
        lstGiamSatChinhSuaPhanMemNoiDungPhoBienDonut.data,
        lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBienDonut.data,
        lstGiamSatChinhSuaPhanMemLyDoPhoBienDonut.data,
        lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBienDonut.data
    ]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRef.current) {
                Plotly.Plots.resize(plotRef.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRef.current) {
                Plotly.purge(plotRef.current);
            }
        };
    }, []);

    // const options = {
    //     plugins: {
    //       legend: {
    //         display: false,
    //       },
    //       datalabels: {
    //         display: true,
    //         align: 'center',
    //         anchor: 'center',
    //         font: {
    //           size: 20,
    //           weight: 'bold',
    //         },
    //         formatter: (value, context) => {
    //           // Display custom text in the center of the chart
    //           const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
    //           const percentage = ((value / total) * 100).toFixed(2);
    //           if (context.dataIndex === 0) {  // Show text only once in the center
    //             return 'Center Text';
    //           }
    //           return '';  // Hide for other segments
    //         },
    //         color: '#000',
    //       },
    //     },
    //     cutout: '80%',  // Adjust to make more space in the center
    //   };

    // const labels = Utils.months({count: 7});
    // const dataLine = {
    // labels: labels,
    // datasets: [{
    //     label: 'My First Dataset',
    //     data: [65, 59, 80, 81, 56, 55, 40],
    //     fill: false,
    //     borderColor: 'rgb(75, 192, 192)',
    //     tension: 0.1
    // }]
    // };

    const aggregateDataByWeekMethod = (data) => {
        const groupedData = {};

        // Group data by week
        data.forEach((point) => {
            const weekStart = moment(point.date)
                .startOf('week')
                .format('YYYY-MM-DD');
            if (!groupedData[weekStart]) {
                groupedData[weekStart] = {totalUpdate: 0, totalDelete: 0};
            }
            groupedData[weekStart].totalUpdate += point.totalUpdate;
            groupedData[weekStart].totalDelete += point.totalDelete;
        });

        // Calculate date range
        const dates = data.map((point) => new Date(point.date));
        const minDate = moment(Math.min(...dates)).startOf('week');
        const maxDate = moment(Math.max(...dates)).startOf('week');

        // Generate all weeks within the range
        const allWeeks = [];
        let currentWeek = minDate;
        while (currentWeek <= maxDate) {
            allWeeks.push(currentWeek.format('YYYY-MM-DD'));
            currentWeek.add(1, 'week');
        }

        // Ensure every week has values
        const xValues = allWeeks;
        const totalUpdateValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].totalUpdate : 0
        );
        const totalDeleteValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].totalDelete : 0
        );

        return {xValues, totalUpdateValues, totalDeleteValues};
    };

    const aggregateDataByMonthMethod = (data) => {
        const groupedData = {};

        // Group data by month
        data.forEach((point) => {
            const monthStart = moment(point.date)
                .startOf('month')
                .format('YYYY-MM-DD');
            if (!groupedData[monthStart]) {
                groupedData[monthStart] = {totalUpdate: 0, totalDelete: 0};
            }
            groupedData[monthStart].totalUpdate += point.totalUpdate;
            groupedData[monthStart].totalDelete += point.totalDelete;
        });

        // Calculate date range
        const dates = data.map((point) => new Date(point.date));
        const minDate = moment(Math.min(...dates)).startOf('month');
        const maxDate = moment(Math.max(...dates)).startOf('month');

        // Generate all months within the range
        const allMonths = [];
        let currentMonth = minDate;
        while (currentMonth <= maxDate) {
            allMonths.push(currentMonth.format('YYYY-MM-DD'));
            currentMonth.add(1, 'month');
        }

        // Ensure every month has values
        const xValues = allMonths;
        const totalUpdateValues = xValues.map((month) =>
            groupedData[month] ? groupedData[month].totalUpdate : 0
        );
        const totalDeleteValues = xValues.map((month) =>
            groupedData[month] ? groupedData[month].totalDelete : 0
        );

        return {xValues, totalUpdateValues, totalDeleteValues};
    };

    const plotRefUpdate = useRef(null);
    const plotRefDelete = useRef(null);

    useEffect(() => {
        if (
            plotRefUpdate.current &&
            plotRefDelete.current &&
            lstCountMethodLine &&
            lstCountMethodLine.data
        ) {
            // Update Plot Data
            // const updateMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalUpdate),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Update Markers',
            //     marker: {color: 'blue', size: 6}
            // };

            let xValues, yUpdateValues, yDeleteValues;

            switch (displayByMethod) {
                case 'week':
                    const aggregatedByWeek = aggregateDataByWeekMethod(
                        lstCountMethodLine.data
                    );
                    xValues = aggregatedByWeek.xValues;
                    yUpdateValues = aggregatedByWeek.totalUpdateValues;
                    yDeleteValues = aggregatedByWeek.totalDeleteValues;
                    break;

                case 'month':
                    const aggregatedByMonth = aggregateDataByMonthMethod(
                        lstCountMethodLine.data
                    );
                    xValues = aggregatedByMonth.xValues;
                    yUpdateValues = aggregatedByMonth.totalUpdateValues;
                    yDeleteValues = aggregatedByMonth.totalDeleteValues;
                    break;
                case 'date':
                    xValues = lstCountMethodLine.data.map(
                        (point) => point.date
                    );
                    yUpdateValues = lstCountMethodLine.data.map(
                        (point) => point.totalUpdate
                    );
                    yDeleteValues = lstCountMethodLine.data.map(
                        (point) => point.totalDelete
                    );
                default:
                    break;
            }

            const updateLines = {
                x: xValues,
                y: yUpdateValues,
                mode: 'lines+markers+text',
                type: 'scatter',
                name: 'Cập nhật',
                line: {color: 'blue', width: 2},
                connectgaps: false,
                text: yUpdateValues.map((y) => formatNumber(y).toString()), // Convert Y values to strings for display
                textposition: 'top center', // Position text on top of the markers
                textfont: {
                    size: 10, // Adjust font size if needed
                    color: 'black' // Change text color if necessary
                }
            };

            // const updateData = [updateMarkers, updateLines];
            const updateData = [updateLines];

            const updateLayout = {
                title: 'Biểu đồ số lượng Cập nhật',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    // type: 'date',
                    tickformat:
                        displayByMethod === 'month'
                            ? '%b<br>%Y'
                            : displayByMethod === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    tickangle: 0,
                    nticks: xValues.length
                    // tickmode: 'array',
                },
                yaxis: {title: 'Số lượng Cập nhật'}
            };

            // Delete Plot Data
            // const deleteMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalDelete),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Delete Markers',
            //     marker: {color: 'red', size: 6}
            // };

            const deleteLines = {
                x: xValues,
                y: yDeleteValues,
                mode: 'lines+markers+text',
                // type: 'scatter',
                name: 'Xoá',
                line: {color: 'red', width: 2},
                connectgaps: false,
                text: yUpdateValues.map((y) => formatNumber(y).toString()), // Convert Y values to strings for display
                textposition: 'top center', // Position text on top of the markers
                textfont: {
                    size: 10, // Adjust font size if needed
                    color: 'black' // Change text color if necessary
                }
            };

            // const deleteData = [deleteMarkers, deleteLines];
            const deleteData = [deleteLines];

            const deleteLayout = {
                title: 'Biểu đồ số lượng Xoá',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                        displayByMethod === 'month'
                            ? '%b<br>%Y'
                            : displayByMethod === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    nticks: xValues.length,
                    tickangle: 0
                },
                yaxis: {title: 'Số lượng Xoá'}
            };

            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefUpdate.current,
                updateData,
                updateLayout,
                config
            );

            // Render Delete Plot
            Plotly.newPlot(
                plotRefDelete.current,
                deleteData,
                deleteLayout,
                config
            );
        } else {
            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefUpdate.current,
                [],
                {title: 'Biểu đồ số lượng Cập nhật'},
                config
            );

            // Render Delete Plot
            Plotly.newPlot(
                plotRefDelete.current,
                [],
                {title: 'Biểu đồ số lượng Xoá'},
                config
            );
        }
    }, [lstCountMethodLine.data, displayByMethod]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefUpdate.current) {
                Plotly.Plots.resize(plotRefUpdate.current);
            }
            if (plotRefDelete.current) {
                Plotly.Plots.resize(plotRefDelete.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefUpdate.current) {
                Plotly.purge(plotRefUpdate.current);
            }
            if (plotRefDelete.current) {
                Plotly.purge(plotRefDelete.current);
            }
        };
    }, []);

    // Function to aggregate data by month
    const aggregateDataByMonth = (data) => {
        const aggregatedData = {};

        // Group the data by month
        data.forEach((point) => {
            const date = new Date(point.ngayDeNghi);
            const monthKey =
                date.getFullYear() +
                '-' +
                ('0' + (date.getMonth() + 1)).slice(-2); // Format: 'YYYY-MM'

            if (!aggregatedData[monthKey]) {
                aggregatedData[monthKey] = 0;
            }
            aggregatedData[monthKey] += point.soLuongDeNghi;
        });

        // Get the full date range from the data
        const dates = data.map((point) => new Date(point.ngayDeNghi));
        const minDate = moment(Math.min(...dates));
        const maxDate = moment(Math.max(...dates));

        // Generate all months within the range
        const allMonths = [];
        let currentMonth = minDate.startOf('month');
        while (currentMonth <= maxDate) {
            allMonths.push(currentMonth.format('YYYY-MM'));
            currentMonth.add(1, 'month');
        }

        // Ensure every month has a value, defaulting to 0
        const xValues = allMonths;
        const yValues = xValues.map((month) => aggregatedData[month] || 0);

        return {xValues, yValues};
    };

    const aggregateDataByWeek = (data) => {
        const groupedData = {};

        // Group the data by week start date
        data.forEach((point) => {
            const weekStart = moment(point.ngayDeNghi)
                .startOf('week')
                .format('YYYY-MM-DD');
            if (!groupedData[weekStart]) {
                groupedData[weekStart] = 0;
            }
            groupedData[weekStart] += point.soLuongDeNghi;
        });

        // Get the full date range from the data
        const dates = data.map((point) => new Date(point.ngayDeNghi));
        const minDate = moment(Math.min(...dates));
        const maxDate = moment(Math.max(...dates));

        // Generate all weeks within the range
        const allWeeks = [];
        let currentWeek = minDate.startOf('week');
        while (currentWeek <= maxDate) {
            allWeeks.push(currentWeek.format('YYYY-MM-DD'));
            currentWeek.add(1, 'week');
        }

        // Ensure every week has a value, defaulting to 0
        const xValues = allWeeks;
        const yValues = xValues.map((week) => groupedData[week] || 0);

        return {xValues, yValues};
    };

    const plotRefSoLuongDeNghiGiamSatPhanMem = useRef(null);
    const plotRefSoLuongDeNghiGiamSatDuLieuBenhVien = useRef(null);

    useEffect(() => {
        if (
            plotRefSoLuongDeNghiGiamSatPhanMem.current &&
            lstCountSLDNPMMethodLine &&
            lstCountSLDNPMMethodLine.data
        ) {
            // Update Plot Data
            // const updateMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalUpdate),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Update Markers',
            //     marker: {color: 'blue', size: 6}
            // };

            let xValues, yValues;

            switch (displayBy) {
                case 'month':
                    const aggregated = aggregateDataByMonth(
                        lstCountSLDNPMMethodLine.data
                    );
                    xValues = aggregated.xValues;
                    yValues = aggregated.yValues;
                    break;
                case 'week':
                    const aggregatedByWeek = aggregateDataByWeek(
                        lstCountSLDNPMMethodLine.data
                    );
                    xValues = aggregatedByWeek.xValues;
                    yValues = aggregatedByWeek.yValues;
                    break;
                case 'date':
                    xValues = lstCountSLDNPMMethodLine.data.map(
                        (point) => point.ngayDeNghi
                    );
                    yValues = lstCountSLDNPMMethodLine.data.map(
                        (point) => point.soLuongDeNghi
                    );
                    break;
                default:
                    break;
            }

            const soLuongDeNghiPhanMemLines = {
                x: xValues,
                y: yValues,
                mode: 'lines+markers+text',
                // type: 'scatter',
                name: 'Số lượng<br>đề nghị',
                line: {color: 'blue', width: 2},
                connectgaps: false,
                text: yValues.map((y) => y.toString()), // Convert Y values to strings for display
                textposition: 'top center', // Position text on top of the markers
                textfont: {
                    size: 10, // Adjust font size if needed
                    color: 'black' // Change text color if necessary
                }
            };

            // const updateData = [updateMarkers, updateLines];
            const soLuongDeNghiPhanMemData = [soLuongDeNghiPhanMemLines];

            // var xMax = soLuongDeNghiPhanMemData[0].x[soLuongDeNghiPhanMemData[0].x.length - 1];
            // var yMax = soLuongDeNghiPhanMemData[0].y[soLuongDeNghiPhanMemData[0].y.length - 1] + 2;

            const soLuongDeNghiPhanMemLayout = {
                title: 'Biểu đồ số lượng đề nghị chỉnh sửa tính năng phần mềm',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                        displayBy === 'month'
                            ? '%b<br>%Y'
                            : displayBy === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    tickangle: 0,
                    nticks: xValues.length
                    // autorange: false, range:[0, xMax]
                },
                yaxis: {
                    title: 'Số lượng đề nghị'
                    // autorange: false, range:[0, yMax]
                }
            };

            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefSoLuongDeNghiGiamSatPhanMem.current,
                soLuongDeNghiPhanMemData,
                soLuongDeNghiPhanMemLayout,
                config
            );
        }
    }, [lstCountSLDNPMMethodLine.data, displayBy]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefSoLuongDeNghiGiamSatPhanMem.current) {
                Plotly.Plots.resize(plotRefSoLuongDeNghiGiamSatPhanMem.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefSoLuongDeNghiGiamSatPhanMem.current) {
                Plotly.purge(plotRefSoLuongDeNghiGiamSatPhanMem.current);
            }
        };
    }, []);

    useEffect(() => {
        if (
            plotRefSoLuongDeNghiGiamSatDuLieuBenhVien.current &&
            lstCountSLDNDLBVMethodLine &&
            lstCountSLDNDLBVMethodLine.data
        ) {
            let xValues, yValues;

            switch (displayBy) {
                case 'month':
                    const aggregated = aggregateDataByMonth(
                        lstCountSLDNDLBVMethodLine.data
                    );
                    xValues = aggregated.xValues;
                    yValues = aggregated.yValues;
                    break;
                case 'week':
                    const aggregatedByWeek = aggregateDataByWeek(
                        lstCountSLDNDLBVMethodLine.data
                    );
                    xValues = aggregatedByWeek.xValues;
                    yValues = aggregatedByWeek.yValues;
                    break;
                case 'date':
                    xValues = lstCountSLDNDLBVMethodLine.data.map(
                        (point) => point.ngayDeNghi
                    );
                    yValues = lstCountSLDNDLBVMethodLine.data.map(
                        (point) => point.soLuongDeNghi
                    );
                    break;
                default:
                    break;
            }

            const soLuongDeNghiDuLieuBenhVienLines = {
                x: xValues,
                y: yValues,
                mode: 'lines+markers+text',
                // type: 'scatter',
                name: 'Số lượng<br>đề nghị',
                line: {color: 'red', width: 2},
                connectgaps: false,
                text: yValues.map((y) => y.toString()), // Convert Y values to strings for display
                textposition: 'top center', // Position text on top of the markers
                textfont: {
                    size: 10, // Adjust font size if needed
                    color: 'black' // Change text color if necessary
                }
            };

            // const deleteData = [deleteMarkers, deleteLines];
            const soLuongDeNghiDuLieuBenhVienData = [
                soLuongDeNghiDuLieuBenhVienLines
            ];

            const soLuongDeNghiDuLieuBenhVienLayout = {
                title: 'Biểu đồ số lượng đề nghị chỉnh sửa dữ liệu bệnh viện',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                        displayBy === 'month'
                            ? '%b<br>%Y'
                            : displayBy === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    nticks: xValues.length,
                    tickangle: 0
                },
                yaxis: {title: 'Số lượng đề nghị'}
            };

            const config = {responsive: true};

            Plotly.newPlot(
                plotRefSoLuongDeNghiGiamSatDuLieuBenhVien.current,
                soLuongDeNghiDuLieuBenhVienData,
                soLuongDeNghiDuLieuBenhVienLayout,
                config
            );
        }
    }, [lstCountSLDNDLBVMethodLine.data, displayBy]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefSoLuongDeNghiGiamSatDuLieuBenhVien.current) {
                Plotly.Plots.resize(
                    plotRefSoLuongDeNghiGiamSatDuLieuBenhVien.current
                );
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefSoLuongDeNghiGiamSatDuLieuBenhVien.current) {
                Plotly.purge(plotRefSoLuongDeNghiGiamSatDuLieuBenhVien.current);
            }
        };
    }, []);

    const handleApplyMethodDonut = (event, picker) => {
        setDatesMethodDonut({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );
    };
    const handleCancelMethodDonut = (event, picker) => {
        setDatesMethodDonut({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    const handleApplyMethodLine = (event, picker) => {
        setDatesMethodLine({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );
    };
    const handleCancelMethodLine = (event, picker) => {
        setDatesMethodLine({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    const handleApplyGiamSat = (event, picker) => {
        setDatesGiamSat({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );
    };
    const handleCancelGiamSat = (event, picker) => {
        setDatesGiamSat({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    const handleApplySoTienVaDonVi = (event, picker) => {
        setDatesSoTienVaDonVi({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );
    };
    const handleCancelSoTienVaDonVi = (event, picker) => {
        setDatesSoTienVaDonVi({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    const isSameMonthRestriction = (date, otherDate) => {
        return (
            date.isSame(otherDate, 'month') && date.isSame(otherDate, 'year')
        );
    };

    // const handleOnCallback = (start, end, label) => {
    //     return;
    // }

    // const handleEvent = (event, picker) => {
    //     // Reset calendar view to no dates selected (null)
    //     // $('.daterangepicker .calendar-table td.active').removeClass('active');
    //     // $('.daterangepicker .calendar-table td.start-date').removeClass(
    //     //     'start-date'
    //     // );
    //     // $('.daterangepicker .calendar-table td.end-date').removeClass(
    //     //     'end-date'
    //     // );

    //     // $('.daterangepicker select.monthselect').removeAttr('disabled');
    //     // $('.daterangepicker .monthselect option[disabled="disabled"]').removeAttr('disabled');

    //     const startDate = picker.startDate;

    //     if (startDate) {
    //         const startMonth = startDate.month(); // Get the month of the start date (0-11)
    //         // const startYear = startDate.year();
    //         // const rightCalendarYear = parseInt(
    //         //     $('.daterangepicker .right .yearselect').val(),
    //         //     10
    //         // ); // Get the year from the right calendar
    //         // Target the right calendar's monthselect and disable the selected startMonth
    //         $('.daterangepicker .right .monthselect option').each(function() {
    //             if ($(this).val() == startMonth) {
    //                 $(this).attr('disabled', 'disabled'); // Disable the same month
    //             }

    //             // if (startMonth === 11 && rightCalendarYear === startYear) {
    //             //     $('.daterangepicker .right .monthselect').attr('disabled', 'disabled');
    //             // }
    //         });
    //     }

    //     // const startDate = picker.startDate;

    //     // if (startDate) {
    //     //     const startMonth = startDate.month(); // Get the month of the start date (0-11)
    //     //     const startYear = startDate.year(); // Get the year of the start date
    //     //     const rightCalendarYear = parseInt(
    //     //         $('.daterangepicker .right .yearselect').val(),
    //     //         10
    //     //     ); // Get the year from the right calendar

    //     //     // Loop through each option in the right calendar's monthselect
    //     //     $('.daterangepicker .right .monthselect option').each(function () {
    //     //         const rightMonth = parseInt($(this).val(), 10);

    //     //         // Disable the start month only if the right calendar is still in the same year
    //     //         if (
    //     //             rightCalendarYear === startYear &&
    //     //             rightMonth === startMonth
    //     //         ) {
    //     //             $(this).attr('disabled', 'disabled'); // Disable the same month
    //     //         }
    //     //     });

    //     //     // Special case for December:
    //     //     // If startDate is December and the right calendar shows the next year, enable all months in the next year
    //     //     if (startMonth === 11 && rightCalendarYear === startYear) {
    //     //         $('.daterangepicker .right .monthselect option').removeAttr(
    //     //             'disabled'
    //     //         ); // Enable all months in the next year
    //     //     }
    //     // }

    //     // const startDate = picker.startDate;

    //     // if (startDate) {
    //     //     const startMonth = startDate.month(); // Get the start month (0-11)
    //     //     const startYear = startDate.year(); // Get the start year
    //     //     const rightCalendarYear = parseInt(
    //     //         $('.daterangepicker .right .yearselect').val(),
    //     //         10
    //     //     ); // Get the year from the right calendar

    //     //     // If the start month is December, disable all months in the right calendar
    //     //     if (startMonth === 11) {
    //     //         $('.daterangepicker .right .monthselect').attr('disabled', 'disabled');
    //     //     } else {
    //     //         // For other months, disable only the start month if the years match
    //     //         $('.daterangepicker .right .monthselect option').each(
    //     //             function () {
    //     //                 const rightMonth = parseInt($(this).val(), 10);

    //     //                 if (
    //     //                     rightCalendarYear === startYear &&
    //     //                     rightMonth === startMonth
    //     //                 ) {
    //     //                     $(this).attr('disabled', 'disabled'); // Disable the same month as startMonth
    //     //                 } else {
    //     //                     $(this).removeAttr('disabled'); // Enable other months
    //     //                 }
    //     //             }
    //     //         );
    //     //     }
    //     // }
    // };

    // const handleDropdownSelect = (event, picker) => {
    //     const calendarStartDate = picker.startDate;
    //     const calendarEndDate = picker.endDate;
    //     const selectedStartDate = calendarStartDate.clone();
    //     const selectedEndDate = calendarEndDate.clone();

    //     // Add your custom validation logic here
    //     if (picker.container.find('.left td.active').length >= 1 && picker.container.find('.right td.active').length >= 1) {
    //         // Prevent the end date from selecting the same month as the start date
    //         alert('End date month cannot be the same as the start date month');
    //         picker.rightCalendar.month = calendarStartDate.clone();
    //         picker.rightCalendar.year = calendarStartDate.clone().year();
    //     }
    // };

    // const handleEvent = (event, picker) => {
    //     if (picker && picker.startDate && picker.endDate) {
    //         // const calendarStartDate = picker.startDate;
    //         const calendarEndDate = picker.endDate;
    //         const diffInMonths = picker.endDate.diff(picker.startDate, 'months', true);

    //         // Update the right calendar to show the end date's month and year
    //         if (diffInMonths > 2 && picker.container.find('.left td.active, .left td.start-date').length > 0 && picker.container.find('.right td.active, .right td.start-date').length == 0) {
    //             // After the user selects a start date, keep the right panel focused on the end date
    //             if (calendarEndDate) {
    //                 // picker.rightCalendar = {
    //                 //     month: calendarEndDate.clone(), // Full moment object, not just the month
    //                 //     year: calendarEndDate.clone().year()
    //                 // };

    //                 picker.rightCalendar.month = calendarEndDate.clone();
    //                 picker.rightCalendar.year = calendarEndDate.clone().year();
    //                 // console.log("calendarEndDate.clone()", calendarEndDate.clone());
    //                 // console.log("picker.rightCalendar.month", picker.rightCalendar.month.format('MM')); // Log the month formatted correctly
    //                 // console.log("picker.rightCalendar.year", picker.rightCalendar.year); // Log the year

    //                 picker.updateCalendars();
    //             }
    //         }
    //     } else {
    //         console.error('Picker or start/end dates are not available.');
    //     }
    // };

    // const handleEventMethodLineSoLuongDeNghi = (event, picker) => {
    //     if (picker && picker.startDate && picker.endDate) {
    //         const calendarStartDate = picker.startDate;
    //         const calendarEndDate = picker.endDate;

    //         // Get the current month and year from the left and right calendars
    //         const currentLeftMonth = picker.leftCalendar.month;
    //         const currentRightMonth = picker.rightCalendar.month;
    //         const currentLeftYear = picker.leftCalendar.year;
    //         const currentRightYear = picker.rightCalendar.year;

    //         let calendarsNeedUpdate = false;

    //         // Check and update the left calendar (for start date)
    //         if (calendarStartDate) {
    //             const newLeftMonth = calendarStartDate.clone();  // Get the new month for the left calendar
    //             const newLeftYear = calendarStartDate.clone().year();  // Get the new year for the left calendar

    //             // Check if the left calendar's month or year has changed
    //             if (
    //                 (!currentLeftMonth || !currentLeftMonth.isSame(newLeftMonth, 'month')) ||
    //                 currentLeftYear !== newLeftYear
    //             ) {
    //                 picker.leftCalendar.month = newLeftMonth;  // Update to the new month
    //                 picker.leftCalendar.year = newLeftYear;  // Update to the new year
    //                 calendarsNeedUpdate = true;

    //                 console.log("Updated Left Calendar - Month:", picker.leftCalendar.month.format('MM'));
    //                 console.log("Updated Left Calendar - Year:", picker.leftCalendar.year);
    //             }
    //         }

    //         // Check and update the right calendar (for end date)
    //         if (calendarEndDate) {
    //             const newRightMonth = calendarEndDate.clone();  // Get the new month for the right calendar
    //             const newRightYear = calendarEndDate.clone().year();  // Get the new year for the right calendar

    //             // Check if the right calendar's month or year has changed
    //             if (
    //                 (!currentRightMonth || !currentRightMonth.isSame(newRightMonth, 'month')) ||
    //                 currentRightYear !== newRightYear
    //             ) {
    //                 picker.rightCalendar.month = newRightMonth;  // Update to the new month
    //                 picker.rightCalendar.year = newRightYear;  // Update to the new year
    //                 calendarsNeedUpdate = true;

    //                 console.log("Updated Right Calendar - Month:", picker.rightCalendar.month.format('MM'));
    //                 console.log("Updated Right Calendar - Year:", picker.rightCalendar.year);
    //             }
    //         }

    //         // Update the calendars only if there are changes
    //         if (calendarsNeedUpdate) {
    //             picker.updateCalendars();
    //         }

    //     } else {
    //         console.error('Picker or start/end dates are not available.');
    //     }
    // };

    const handleApplyMethodLineSoLuongDeNghi = (event, picker) => {
        setDatesMethodLineSoLuongDeNghi({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );

        // setTimeout(() => {
        //     picker.container.find('.right').click(); // Keeps the focus on the right calendar
        //   }, 0);
    };
    const handleCancelMethodLineSoLuongDeNghi = (event, picker) => {
        setDatesMethodLineSoLuongDeNghi({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    const handleApplyMethodLineCancel = (event, picker) => {
        setDatesMethodLineCancel({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );
    };
    const handleCancelMethodLineCancel = (event, picker) => {
        setDatesMethodLineCancel({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    const handleApplyHMSFeeTraLai = (event, picker) => {
        setDatesHMSFeeTraLai({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );
    };
    const handleCancelHMSFeeTraLai = (event, picker) => {
        setDatesHMSFeeTraLai({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    const handleApplyLineBaoHiem = (event, picker) => {
        setDatesLineBaoHiem({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        picker.element.val(
            `${picker.startDate.format(
                'DD/MM/YYYY HH:mm'
            )} - ${picker.endDate.format('DD/MM/YYYY HH:mm')}`
        );
    };
    const handleCancelLineBaoHiem = (event, picker) => {
        setDatesLineBaoHiem({
            startDate: null,
            endDate: null
        });
        picker.element.val('');
    };

    // const loadOptions = async (inputValue, loadedOptions, {page}) => {
    //     const filteredOptions = lstAccountHis
    //         .filter((option) =>
    //             option.label.toLowerCase().includes(inputValue.toLowerCase())
    //         )
    //         .slice(0, 6);

    //     // Return all filtered options, no matter how many there are
    //     return {
    //         options: filteredOptions,
    //         hasMore: false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };
    // };

    // Function to aggregate data by month
    const aggregateDataByMonthCancel = (data) => {
        const aggregatedData = {};

        // Group data by month
        data.forEach((point) => {
            const date = new Date(point.date);
            const monthKey =
                date.getFullYear() +
                '-' +
                ('0' + (date.getMonth() + 1)).slice(-2); // Format: 'YYYY-MM'

            if (!aggregatedData[monthKey]) {
                aggregatedData[monthKey] = {
                    totalCancel: 0,
                    totalMoney: 0
                };
            }
            aggregatedData[monthKey].totalCancel += point.totalCancel;
            aggregatedData[monthKey].totalMoney += point.totalMoney || 0;
        });

        // Get the full date range
        const dates = data.map((point) => new Date(point.date));
        const minDate = moment(Math.min(...dates)).startOf('month');
        const maxDate = moment(Math.max(...dates)).startOf('month');

        // Generate all months within the range
        const allMonths = [];
        let currentMonth = minDate;
        while (currentMonth <= maxDate) {
            allMonths.push(currentMonth.format('YYYY-MM'));
            currentMonth.add(1, 'month');
        }

        // Ensure every month has default values
        const xValues = allMonths;
        const totalCancelValues = xValues.map((month) =>
            aggregatedData[month] ? aggregatedData[month].totalCancel : 0
        );
        const totalMoneyValues = xValues.map((month) =>
            aggregatedData[month] ? aggregatedData[month].totalMoney : 0
        );

        return {xValues, totalCancelValues, totalMoneyValues};
    };

    const aggregateDataByWeekCancel = (data) => {
        const groupedData = {};

        // Group data by week
        data.forEach((point) => {
            const weekStart = moment(point.date)
                .startOf('week')
                .format('YYYY-MM-DD');

            if (!groupedData[weekStart]) {
                groupedData[weekStart] = {
                    totalCancel: 0,
                    totalMoney: 0
                };
            }
            groupedData[weekStart].totalCancel += point.totalCancel;
            groupedData[weekStart].totalMoney += point.totalMoney || 0;
        });

        // Get the full date range
        const dates = data.map((point) => new Date(point.date));
        const minDate = moment(Math.min(...dates)).startOf('week');
        const maxDate = moment(Math.max(...dates)).startOf('week');

        // Generate all weeks within the range
        const allWeeks = [];
        let currentWeek = minDate;
        while (currentWeek <= maxDate) {
            allWeeks.push(currentWeek.format('YYYY-MM-DD'));
            currentWeek.add(1, 'week');
        }

        // Ensure every week has default values
        const xValues = allWeeks;
        const totalCancelValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].totalCancel : 0
        );
        const totalMoneyValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].totalMoney : 0
        );

        return {xValues, totalCancelValues, totalMoneyValues};
    };

    const plotRefSoLuongCancel = useRef(null);
    const plotRefTongTienCancel = useRef(null);

    useEffect(() => {
        if (
            plotRefSoLuongCancel.current &&
            plotRefTongTienCancel.current &&
            lstCountCancelMethodLine &&
            lstCountCancelMethodLine.data
        ) {
            // Update Plot Data
            // const updateMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalUpdate),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Update Markers',
            //     marker: {color: 'blue', size: 6}
            // };

            let xValues, yCountCancelValues, yTotalMoneyValues;

            switch (displayByCancel) {
                case 'month':
                    const aggregated = aggregateDataByMonthCancel(
                        lstCountCancelMethodLine.data
                    );
                    xValues = aggregated.xValues;
                    yCountCancelValues = aggregated.totalCancelValues;
                    yTotalMoneyValues = aggregated.totalMoneyValues;
                    break;
                case 'week':
                    const aggregatedByWeek = aggregateDataByWeekCancel(
                        lstCountCancelMethodLine.data
                    );
                    xValues = aggregatedByWeek.xValues;
                    yCountCancelValues = aggregatedByWeek.totalCancelValues;
                    yTotalMoneyValues = aggregatedByWeek.totalMoneyValues;
                    break;
                case 'date':
                    xValues = lstCountCancelMethodLine.data.map(
                        (point) => point.date
                    );
                    yCountCancelValues = lstCountCancelMethodLine.data.map(
                        (point) => point.totalCancel
                    );
                    yTotalMoneyValues = lstCountCancelMethodLine.data.map(
                        (point) => point.totalMoney
                    );
                    break;
                default:
                    break;
            }

            const soLuongCancelLines = {
                x: xValues,
                y: yCountCancelValues,
                mode: 'lines+markers+text',
                // type: 'scatter',
                name: 'Số lượng<br>Huỷ',
                line: {color: 'blue', width: 2},
                connectgaps: false,
                text: yCountCancelValues.map((y) => y.toString()), // Convert Y values to strings for display
                textposition: 'top center', // Position text on top of the markers
                textfont: {
                    size: 10, // Adjust font size if needed
                    color: 'black' // Change text color if necessary
                }
            };

            // const deleteData = [deleteMarkers, deleteLines];
            const soLuongCancelData = [soLuongCancelLines];

            const soLuongCancelLayout = {
                title: 'Biểu đồ số lượng Huỷ',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                        displayByCancel === 'month'
                            ? '%b<br>%Y'
                            : displayByCancel === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    nticks: xValues.length,
                    tickangle: 0
                },
                yaxis: {title: 'Số lượng Huỷ'}
            };

            // Delete Plot Data
            // const deleteMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalDelete),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Delete Markers',
            //     marker: {color: 'red', size: 6}
            // };

            const tongTienLines = {
                x: xValues,
                y: yTotalMoneyValues,
                mode: 'lines+markers+text',
                // type: 'scatter',
                name: 'Tổng tiền<br>Huỷ',
                line: {color: 'red', width: 2},
                connectgaps: false,
                text: yTotalMoneyValues.map((y) => new Intl.NumberFormat(
                    'vi-VN',
                    {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    }
                ).format(
                    y
                ).toString()), // Convert Y values to strings for display
                textposition: 'top center', // Position text on top of the markers
                textfont: {
                    size: 10, // Adjust font size if needed
                    color: 'black' // Change text color if necessary
                }
            };

            // const deleteData = [deleteMarkers, deleteLines];
            const tongTienData = [tongTienLines];

            const tongTienLayout = {
                title: 'Biểu đồ tổng tiền Huỷ',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                        displayByCancel === 'month'
                            ? '%b<br>%Y'
                            : displayByCancel === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    nticks: xValues.length,
                    tickangle: 0
                },
                yaxis: {title: 'Tổng tiền Huỷ'},
                annotations: [
                    {
                        xref: 'paper', // Positions the annotation relative to the chart
                        yref: 'paper',
                        x: 1.05, // Position it slightly to the right of the chart
                        y: 1.25, // Align it near the top
                        text: '1M = 1 triệu VNĐ', // Annotation text
                        showarrow: false,
                        font: {
                            size: 12,
                            color: 'black'
                        },
                        align: 'right'
                    },
                    {
                        xref: 'paper', // Positions the annotation relative to the chart
                        yref: 'paper',
                        x: 1.05, // Position it slightly to the right of the chart
                        y: 1.15, // Align it near the top
                        text: '1B = 1 tỷ VNĐ', // Annotation text
                        showarrow: false,
                        font: {
                            size: 12,
                            color: 'black'
                        },
                        align: 'right'
                    }
                ]
            };

            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefSoLuongCancel.current,
                soLuongCancelData,
                soLuongCancelLayout,
                config
            );

            // Render Delete Plot
            Plotly.newPlot(
                plotRefTongTienCancel.current,
                tongTienData,
                tongTienLayout,
                config
            );

            // Plotly.animate(
            //     plotRefSoLuongCancel.current,
            //     {
            //         data: [{x: xValues, y: yCountCancelValues}],
            //         traces: [0],
            //         layout: {}
            //     },
            //     {
            //         transition: {
            //             duration: 500,
            //             easing: 'cubic-in-out'
            //         },
            //         frame: {
            //             duration: 500
            //         }
            //     }
            // );

            // animationGraph(plotRefSoLuongCancel.current, xValues, yCountCancelValues);
            // animationGraph(plotRefTongTienCancel.current, xValues, yTotalMoneyValues);
        } else {
            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefSoLuongCancel.current,
                [],
                {title: 'Biểu đồ số lượng Huỷ'},
                config
            );

            // Render Delete Plot
            Plotly.newPlot(
                plotRefTongTienCancel.current,
                [],
                {title: 'Biểu đồ tổng tiền Huỷ'},
                config
            );
        }
    }, [lstCountCancelMethodLine.data, displayByCancel]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefSoLuongCancel.current) {
                Plotly.Plots.resize(plotRefSoLuongCancel.current);
            }
            if (plotRefTongTienCancel.current) {
                Plotly.Plots.resize(plotRefTongTienCancel.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefSoLuongCancel.current) {
                Plotly.purge(plotRefSoLuongCancel.current);
            }
            if (plotRefTongTienCancel.current) {
                Plotly.purge(plotRefTongTienCancel.current);
            }
        };
    }, []);

    // Function to aggregate data by month
    const aggregateDataByMonthBaoHiem = (data) => {
        const aggregatedData = {};

        // Group data by month
        data.forEach((point) => {
            const date = new Date(point.ngayTao);
            const monthKey =
                date.getFullYear() +
                '-' +
                ('0' + (date.getMonth() + 1)).slice(-2); // Format: 'YYYY-MM'

            if (!aggregatedData[monthKey]) {
                aggregatedData[monthKey] = {
                    tongSoLuong: 0,
                    tongTienBaoHiem: 0
                };
            }
            aggregatedData[monthKey].tongSoLuong += point.tongSoLuong;
            aggregatedData[monthKey].tongTienBaoHiem +=
                point.tongTienBaoHiem || 0;
        });

        // Get the full date range
        const dates = data.map((point) => new Date(point.ngayTao));
        const minDate = moment(Math.min(...dates)).startOf('month');
        const maxDate = moment(Math.max(...dates)).startOf('month');

        // Generate all months within the range
        const allMonths = [];
        let currentMonth = minDate;
        while (currentMonth <= maxDate) {
            allMonths.push(currentMonth.format('YYYY-MM'));
            currentMonth.add(1, 'month');
        }

        // Ensure every month has default values
        const xValues = allMonths;
        const tongSoLuongValues = xValues.map((month) =>
            aggregatedData[month] ? aggregatedData[month].tongSoLuong : 0
        );
        const tongTienBaoHiemValues = xValues.map((month) =>
            aggregatedData[month] ? aggregatedData[month].tongTienBaoHiem : 0
        );

        return {xValues, tongSoLuongValues, tongTienBaoHiemValues};
    };

    const aggregateDataByWeekBaoHiem = (data) => {
        const groupedData = {};

        // Group data by week
        data.forEach((point) => {
            const weekStart = moment(point.ngayTao)
                .startOf('week')
                .format('YYYY-MM-DD');

            if (!groupedData[weekStart]) {
                groupedData[weekStart] = {
                    tongSoLuong: 0,
                    tongTienBaoHiem: 0
                };
            }
            groupedData[weekStart].tongSoLuong += point.tongSoLuong;
            groupedData[weekStart].tongTienBaoHiem +=
                point.tongTienBaoHiem || 0;
        });

        // Get the full date range
        const dates = data.map((point) => new Date(point.ngayTao));
        const minDate = moment(Math.min(...dates)).startOf('week');
        const maxDate = moment(Math.max(...dates)).startOf('week');

        // Generate all weeks within the range
        const allWeeks = [];
        let currentWeek = minDate;
        while (currentWeek <= maxDate) {
            allWeeks.push(currentWeek.format('YYYY-MM-DD'));
            currentWeek.add(1, 'week');
        }

        // Ensure every week has default values
        const xValues = allWeeks;
        const tongSoLuongValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].tongSoLuong : 0
        );
        const tongTienBaoHiemValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].tongTienBaoHiem : 0
        );

        return {xValues, tongSoLuongValues, tongTienBaoHiemValues};
    };

    const plotRefSoLuongBaoHiem = useRef(null);
    const plotRefTongTienBaoHiem = useRef(null);

    useEffect(() => {
        if (
            plotRefSoLuongBaoHiem.current &&
            plotRefTongTienBaoHiem.current &&
            lstCountBaoHiemLine &&
            lstCountBaoHiemLine.data
        ) {
            // Update Plot Data
            // const updateMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalUpdate),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Update Markers',
            //     marker: {color: 'blue', size: 6}
            // };

            let xValues, yCountBaoHiemValues, yTongTienBaoHiemValues;

            switch (displayByBaoHiem) {
                case 'month':
                    const aggregated = aggregateDataByMonthBaoHiem(
                        lstCountBaoHiemLine.data
                    );
                    xValues = aggregated.xValues;
                    yCountBaoHiemValues = aggregated.tongSoLuongValues;
                    yTongTienBaoHiemValues = aggregated.tongTienBaoHiemValues;
                    break;
                case 'week':
                    const aggregatedByWeek = aggregateDataByWeekBaoHiem(
                        lstCountBaoHiemLine.data
                    );
                    xValues = aggregatedByWeek.xValues;
                    yCountBaoHiemValues = aggregatedByWeek.tongSoLuongValues;
                    yTongTienBaoHiemValues =
                        aggregatedByWeek.tongTienBaoHiemValues;
                    break;
                case 'date':
                    xValues = lstCountBaoHiemLine.data.map(
                        (point) => point.ngayTao
                    );
                    yCountBaoHiemValues = lstCountBaoHiemLine.data.map(
                        (point) => point.tongSoLuong
                    );
                    yTongTienBaoHiemValues = lstCountBaoHiemLine.data.map(
                        (point) => point.tongTienBaoHiem
                    );
                    break;
                default:
                    break;
            }

            const soLuongBaoHiemLines = {
                x: xValues,
                y: yCountBaoHiemValues,
                mode: 'lines+markers',
                // type: 'scatter',
                name: 'Số lượng<br>Bảo hiểm',
                line: {color: 'blue', width: 2},
                connectgaps: false
            };

            // const deleteData = [deleteMarkers, deleteLines];
            const soLuongBaoHiemData = [soLuongBaoHiemLines];

            const soLuongBaoHiemLayout = {
                title: 'Biểu đồ số lượng bảo hiểm',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                        displayByBaoHiem === 'month'
                            ? '%b<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    tickangle: 0,
                    nticks: xValues.length
                },
                yaxis: {title: 'Số lượng Bảo hiểm'}
            };

            // Delete Plot Data
            const tongTienBaoHiemLines = {
                x: xValues,
                y: yTongTienBaoHiemValues,
                mode: 'lines+markers',
                // type: 'scatter',
                name: 'Tổng tiền<br>Bảo hiểm',
                line: {color: 'red', width: 2},
                connectgaps: false
            };

            // const deleteData = [deleteMarkers, deleteLines];
            const tongTienBaohiemData = [tongTienBaoHiemLines];

            const tongTienBaoHiemLayout = {
                title: 'Biểu đồ tổng tiền Bảo hiểm',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                        displayByBaoHiem === 'month'
                            ? '%b<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    tickangle: 0,
                    nticks: xValues.length
                },
                yaxis: {title: 'Tổng tiền Bảo hiểm'},
                annotations: [
                    {
                        xref: 'paper', // Positions the annotation relative to the chart
                        yref: 'paper',
                        x: 1.05, // Position it slightly to the right of the chart
                        y: 1.25, // Align it near the top
                        text: '1M = 1 triệu VNĐ', // Annotation text
                        showarrow: false,
                        font: {
                            size: 12,
                            color: 'black'
                        },
                        align: 'right'
                    },
                    {
                        xref: 'paper', // Positions the annotation relative to the chart
                        yref: 'paper',
                        x: 1.05, // Position it slightly to the right of the chart
                        y: 1.15, // Align it near the top
                        text: '1B = 1 tỷ VNĐ', // Annotation text
                        showarrow: false,
                        font: {
                            size: 12,
                            color: 'black'
                        },
                        align: 'right'
                    }
                ]
            };

            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefSoLuongBaoHiem.current,
                soLuongBaoHiemData,
                soLuongBaoHiemLayout,
                config
            );

            // Render Delete Plot
            Plotly.newPlot(
                plotRefTongTienBaoHiem.current,
                tongTienBaohiemData,
                tongTienBaoHiemLayout,
                config
            );
        }
    }, [lstCountBaoHiemLine.data, displayByBaoHiem]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefSoLuongBaoHiem.current) {
                Plotly.Plots.resize(plotRefSoLuongBaoHiem.current);
            }
            if (plotRefTongTienBaoHiem.current) {
                Plotly.Plots.resize(plotRefTongTienBaoHiem.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefSoLuongBaoHiem.current) {
                Plotly.purge(plotRefSoLuongBaoHiem.current);
            }
            if (plotRefTongTienBaoHiem.current) {
                Plotly.purge(plotRefTongTienBaoHiem.current);
            }
        };
    }, []);

    const plotRefNoiDungGiamSat = useRef(null);
    const plotRefLyDoGiamSat = useRef(null);

    useEffect(() => {
        if (
            plotRefNoiDungGiamSat.current &&
            plotRefLyDoGiamSat.current &&
            lstGiamSatChinhSuaPhanMemNoiDungPhoBien &&
            lstGiamSatChinhSuaPhanMemNoiDungPhoBien.data &&
            lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBien &&
            lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBien.data &&
            lstGiamSatChinhSuaPhanMemLyDoPhoBien &&
            lstGiamSatChinhSuaPhanMemLyDoPhoBien.data &&
            lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBien &&
            lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBien.data
        ) {
            const noiDungAggregated = combineAndAggregateData(
                lstGiamSatChinhSuaPhanMemNoiDungPhoBien.data,
                lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBien.data,
                'noiDung'
            );

            // Aggregate data for Lý do
            const lyDoAggregated = combineAndAggregateData(
                lstGiamSatChinhSuaPhanMemLyDoPhoBien.data,
                lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBien.data,
                'lyDo'
            );

            // // Data for Nội dung chỉnh sửa chart
            // const noiDungKeys = Object.keys(noiDungAggregated);
            // const noiDungValues = noiDungKeys.map(
            //     (key) => noiDungAggregated[key]
            // );

            // Sort Nội dung data by TanSuat in descending order
            const sortedNoiDung = Object.entries(noiDungAggregated)
                .sort((a, b) => a[1] - b[1]) // Sort by value (TanSuat)
                .reduce(
                    (acc, [key, value]) => {
                        acc.keys.push(sanitizeHtml(key));
                        acc.values.push(value);
                        return acc;
                    },
                    {keys: [], values: []}
                );

            // Sort Lý do data by TanSuat in descending order
            const sortedLyDo = Object.entries(lyDoAggregated)
                .sort((a, b) => a[1] - b[1]) // Sort by value (TanSuat)
                .reduce(
                    (acc, [key, value]) => {
                        acc.keys.push(sanitizeHtml(key));
                        acc.values.push(value);
                        return acc;
                    },
                    {keys: [], values: []}
                );

            const noiDungData = [
                {
                    x: sortedNoiDung.values,
                    y: sortedNoiDung.keys,
                    type: 'bar',
                    orientation: 'h',
                    name: 'Nội dung chỉnh sửa',
                    marker: {color: 'blue'},
                    text: sortedNoiDung.values.map((val) => val.toString()), // Add numbers as text
                    textposition: 'outside'
                }
            ];

            // Layout for Nội dung chỉnh sửa chart
            const noiDungLayout = {
                title: 'Biểu đồ Nội dung chỉnh sửa',
                xaxis: {title: 'Tần suất', automargin: true},
                yaxis: {title: 'Nội dung', automargin: true}
            };

            // Render Nội dung chỉnh sửa chart
            Plotly.newPlot(
                plotRefNoiDungGiamSat.current,
                noiDungData,
                noiDungLayout,
                {responsive: true}
            );

            // Data for Lý do chỉnh sửa chart
            // const lyDoKeys = Object.keys(lyDoAggregated);
            // const lyDoValues = lyDoKeys.map((key) => lyDoAggregated[key]);
            const lyDoData = [
                {
                    x: sortedLyDo.values,
                    y: sortedLyDo.keys,
                    type: 'bar',
                    orientation: 'h',
                    name: 'Lý do chỉnh sửa',
                    marker: {color: 'red'},
                    text: sortedLyDo.values.map((val) => val.toString()), // Add numbers as text
                    textposition: 'outside'
                }
            ];

            // Layout for Lý do chỉnh sửa chart
            const lyDoLayout = {
                title: 'Biểu đồ Lý do chỉnh sửa',
                xaxis: {title: 'Tần suất', automargin: true},
                yaxis: {title: 'Lý do', automargin: true}
            };

            // Render Lý do chỉnh sửa chart
            Plotly.newPlot(plotRefLyDoGiamSat.current, lyDoData, lyDoLayout, {
                responsive: true
            });
        }
    }, [
        lstGiamSatChinhSuaPhanMemNoiDungPhoBien.data,
        lstGiamSatChinhSuaDuLieuBenhVienNoiDungPhoBien.data,
        lstGiamSatChinhSuaPhanMemLyDoPhoBien.data,
        lstGiamSatChinhSuaDuLieuBenhVienLyDoPhoBien.data
    ]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefNoiDungGiamSat.current) {
                Plotly.Plots.resize(plotRefNoiDungGiamSat.current);
            }
            if (plotRefLyDoGiamSat.current) {
                Plotly.Plots.resize(plotRefLyDoGiamSat.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefNoiDungGiamSat.current) {
                Plotly.purge(plotRefNoiDungGiamSat.current);
            }
            if (plotRefLyDoGiamSat.current) {
                Plotly.purge(plotRefLyDoGiamSat.current);
            }
        };
    }, []);

    const aggregateDataByWeekSoTienChenhLech = (data) => {
        const groupedData = {};

        // Group data by week
        data.forEach((point) => {
            const weekStart = moment(point.ngayDeNghi)
                .startOf('week')
                .format('YYYY-MM-DD');
            if (!groupedData[weekStart]) {
                groupedData[weekStart] = {tongTienChenhLech: 0};
            }
            groupedData[weekStart].tongTienChenhLech +=
                point.tongTienChenhLech || 0;
        });

        // Get the full date range
        const dates = data.map((point) => new Date(point.ngayDeNghi));
        const minDate = moment(Math.min(...dates)).startOf('week');
        const maxDate = moment(Math.max(...dates)).startOf('week');

        // Generate all weeks within the range
        const allWeeks = [];
        let currentWeek = minDate;
        while (currentWeek <= maxDate) {
            allWeeks.push(currentWeek.format('YYYY-MM-DD'));
            currentWeek.add(1, 'week');
        }

        // Ensure every week has default values
        const xValues = allWeeks;
        const yValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].tongTienChenhLech : 0
        );

        return {xValues, yValues};
    };

    const aggregateDataByMonthSoTienChenhLech = (data) => {
        const aggregatedData = {};

        // Group data by month
        data.forEach((point) => {
            const date = new Date(point.ngayDeNghi);
            const monthKey =
                date.getFullYear() +
                '-' +
                ('0' + (date.getMonth() + 1)).slice(-2); // Format: 'YYYY-MM'

            if (!aggregatedData[monthKey]) {
                aggregatedData[monthKey] = 0;
            }
            aggregatedData[monthKey] += point.tongTienChenhLech || 0;
        });

        // Get the full date range
        const dates = data.map((point) => new Date(point.ngayDeNghi));
        const minDate = moment(Math.min(...dates)).startOf('month');
        const maxDate = moment(Math.max(...dates)).startOf('month');

        // Generate all months within the range
        const allMonths = [];
        let currentMonth = minDate;
        while (currentMonth <= maxDate) {
            allMonths.push(currentMonth.format('YYYY-MM'));
            currentMonth.add(1, 'month');
        }

        // Ensure every month has default values
        const xValues = allMonths;
        const yValues = xValues.map((month) =>
            aggregatedData[month] ? aggregatedData[month] : 0
        );

        return {xValues, yValues};
    };

    const plotRefSoTienChenhLech = useRef(null);
    const plotRefDonViDeNghi = useRef(null);

    useEffect(() => {
        if (
            plotRefSoTienChenhLech.current &&
            lstSoTienChenhLechBar &&
            lstSoTienChenhLechBar.data
        ) {
            // Update Plot Data
            // const updateMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalUpdate),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Update Markers',
            //     marker: {color: 'blue', size: 6}
            // };

            let xValues, yValues;

            switch (displayBySoTienVaDonVi) {
                case 'week':
                    const aggregatedByWeek = aggregateDataByWeekSoTienChenhLech(
                        lstSoTienChenhLechBar.data
                    );
                    xValues = aggregatedByWeek.xValues;
                    yValues = aggregatedByWeek.yValues;
                    break;
                case 'month':
                    const aggregatedByMonth =
                        aggregateDataByMonthSoTienChenhLech(
                            lstSoTienChenhLechBar.data
                        );
                    xValues = aggregatedByMonth.xValues;
                    yValues = aggregatedByMonth.yValues;
                    break;
                default:
                    break;
            }

            const barColors = yValues.map((value) =>
                value < 0 ? 'red' : 'blue'
            );

            // Update Plot Data for Update Chart
            const updateData = [
                {
                    x: xValues,
                    y: yValues,
                    type: 'bar',
                    name: 'Số tiền chênh lệch',
                    marker: {color: barColors},
                    text: yValues.map((value) => formatNumber(value)),
                    textfont: {
                        size: 12, // Increase text size
                        color: 'black' // Optionally set the text color
                    },
                    textposition: 'outside' // Place numbers on top of bars
                }
            ];

            const updateLayout = {
                title: 'Biểu đồ Số tiền chênh lệch',
                showlegend: false,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                        displayBySoTienVaDonVi === 'month'
                            ? '%b<br>%Y'
                            : displayBySoTienVaDonVi === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    nticks: xValues.length,
                    tickangle: 0
                },
                yaxis: {
                    title: 'Số tiền chênh lệch',
                    automargin: true, // Ensure space for labels
                    range: [
                        Math.min(...yValues) > 0
                            ? 0
                            : Math.min(...yValues) * 1.1, // Add some padding below the smallest bar
                        Math.max(...yValues) * 3 // Add some padding above the tallest bar
                    ]
                }
            };

            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefSoTienChenhLech.current,
                updateData,
                updateLayout,
                config
            );
        }
    }, [lstSoTienChenhLechBar.data, displayBySoTienVaDonVi]);

    useEffect(() => {
        if (
            plotRefSoTienChenhLech.current &&
            lstDonViTanSuatBar &&
            lstDonViTanSuatBar.data
        ) {
            // Sort Nội dung data by TanSuat in descending order
            const sortedDonViTanSuat = lstDonViTanSuatBar.data.sort(
                (a, b) => a.tanSuat - b.tanSuat
            );

            const donViData = [
                {
                    x: sortedDonViTanSuat.map((point) => point.tanSuat),
                    y: sortedDonViTanSuat.map((point) => point.tenDonVi),
                    type: 'bar',
                    orientation: 'h',
                    name: 'Đơn vị và tần suất',
                    marker: {color: 'blue'},
                    text: sortedDonViTanSuat.map((val) =>
                        val.tanSuat.toString()
                    ), // Add numbers as text
                    textposition: 'outside'
                }
            ];

            // Layout for Nội dung chỉnh sửa chart
            const donViLayout = {
                title: 'Biểu đồ Đơn vị đề nghị và tần suất',
                xaxis: {title: 'Tần suất', automargin: true},
                yaxis: {title: 'Đơn vị', automargin: true}
            };

            // Render Nội dung chỉnh sửa chart
            Plotly.newPlot(plotRefDonViDeNghi.current, donViData, donViLayout, {
                responsive: true
            });
        }
    }, [lstDonViTanSuatBar.data]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefSoTienChenhLech.current) {
                Plotly.Plots.resize(plotRefSoTienChenhLech.current);
            }
            if (plotRefDonViDeNghi.current) {
                Plotly.Plots.resize(plotRefDonViDeNghi.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefSoTienChenhLech.current) {
                Plotly.purge(plotRefSoTienChenhLech.current);
            }
            if (plotRefDonViDeNghi.current) {
                Plotly.purge(plotRefDonViDeNghi.current);
            }
        };
    }, []);

    // HMS Fee Tra lai

    // Function to aggregate data by month
    const aggregateDataByMonthHMSFeeTraLai = (data) => {
        const aggregatedData = {};

        // Group data by month
        data.forEach((point) => {
            const date = new Date(point.date);
            const monthKey =
                date.getFullYear() +
                '-' +
                ('0' + (date.getMonth() + 1)).slice(-2); // Format: 'YYYY-MM'

            if (!aggregatedData[monthKey]) {
                aggregatedData[monthKey] = {
                    totalCountTraLai: 0,
                    totalMoney: 0
                };
            }
            aggregatedData[monthKey].totalCountTraLai += point.totalCountTraLai;
            aggregatedData[monthKey].totalMoney += point.totalMoney || 0;
        });

        // Get the full date range
        const dates = data.map((point) => new Date(point.date));
        const minDate = moment(Math.min(...dates)).startOf('month');
        const maxDate = moment(Math.max(...dates)).startOf('month');

        // Generate all months within the range
        const allMonths = [];
        let currentMonth = minDate;
        while (currentMonth <= maxDate) {
            allMonths.push(currentMonth.format('YYYY-MM'));
            currentMonth.add(1, 'month');
        }

        // Ensure every month has default values
        const xValues = allMonths;
        const totalCountTraLaiValues = xValues.map((month) =>
            aggregatedData[month] ? aggregatedData[month].totalCountTraLai : 0
        );
        const totalMoneyValues = xValues.map((month) =>
            aggregatedData[month] ? aggregatedData[month].totalMoney : 0
        );

        return {xValues, totalCountTraLaiValues, totalMoneyValues};
    };

    const aggregateDataByWeekHMSFeeHMSFeeTraLai = (data) => {
        const groupedData = {};

        // Group data by week
        data.forEach((point) => {
            const weekStart = moment(point.date)
                .startOf('week')
                .format('YYYY-MM-DD');

            if (!groupedData[weekStart]) {
                groupedData[weekStart] = {
                    totalCountTraLai: 0,
                    totalMoney: 0
                };
            }
            groupedData[weekStart].totalCountTraLai += point.totalCountTraLai;
            groupedData[weekStart].totalMoney += point.totalMoney || 0;
        });

        // Get the full date range
        const dates = data.map((point) => new Date(point.date));
        const minDate = moment(Math.min(...dates)).startOf('week');
        const maxDate = moment(Math.max(...dates)).startOf('week');

        // Generate all weeks within the range
        const allWeeks = [];
        let currentWeek = minDate;
        while (currentWeek <= maxDate) {
            allWeeks.push(currentWeek.format('YYYY-MM-DD'));
            currentWeek.add(1, 'week');
        }

        // Ensure every week has default values
        const xValues = allWeeks;
        const totalCountTraLaiValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].totalCountTraLai : 0
        );
        const totalMoneyValues = xValues.map((week) =>
            groupedData[week] ? groupedData[week].totalMoney : 0
        );

        return {xValues, totalCountTraLaiValues, totalMoneyValues};
    };

    const plotRefSoLuongHMSFeeTraLai = useRef(null);
    const plotRefTongTienHMSFeeTraLai = useRef(null);

    useEffect(() => {
        if (
            plotRefSoLuongHMSFeeTraLai.current &&
            plotRefTongTienHMSFeeTraLai.current &&
            lstCountHMSFeeTraLai &&
            lstCountHMSFeeTraLai.data
        ) {
            // Update Plot Data
            // const updateMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalUpdate),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Update Markers',
            //     marker: {color: 'blue', size: 6}
            // };

            let xValues, yCountTraLaiValues, yTotalMoneyValues;

            switch (displayByHMSFeeTraLai) {
                case 'month':
                    const aggregated = aggregateDataByMonthHMSFeeTraLai(
                        lstCountHMSFeeTraLai.data
                    );
                    xValues = aggregated.xValues;
                    yCountTraLaiValues = aggregated.totalCountTraLaiValues;
                    yTotalMoneyValues = aggregated.totalMoneyValues;
                    break;
                case 'week':
                    const aggregatedByWeek = aggregateDataByWeekHMSFeeHMSFeeTraLai(
                        lstCountHMSFeeTraLai.data
                    );
                    xValues = aggregatedByWeek.xValues;
                    yCountTraLaiValues = aggregatedByWeek.totalCountTraLaiValues;
                    yTotalMoneyValues = aggregatedByWeek.totalMoneyValues;
                    break;
                case 'date':
                    xValues = lstCountHMSFeeTraLai.data.map(
                        (point) => point.date
                    );
                    yCountTraLaiValues = lstCountHMSFeeTraLai.data.map(
                        (point) => point.totalCountTraLai
                    );
                    yTotalMoneyValues = lstCountHMSFeeTraLai.data.map(
                        (point) => point.totalMoney
                    );
                    break;
                default:
                    break;
            }

            const soLuongTraLaiLines = {
                x: xValues,
                y: yCountTraLaiValues,
                mode: 'lines+markers+text',
                // type: 'scatter',
                name: 'Số lượng<br>Trả lại',
                line: {color: 'blue', width: 2},
                connectgaps: false,
                text: yCountTraLaiValues.map((y) => y.toString()), // Convert Y values to strings for display
                textposition: 'top center', // Position text on top of the markers
                textfont: {
                    size: 10, // Adjust font size if needed
                    color: 'black' // Change text color if necessary
                }
            };

            // const deleteData = [deleteMarkers, deleteLines];
            const soLuongTraLaiData = [soLuongTraLaiLines];

            const soLuongTraLaiLayout = {
                title: 'Biểu đồ Số lượng trả lại',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                    displayByHMSFeeTraLai === 'month'
                            ? '%b<br>%Y'
                            : displayByHMSFeeTraLai === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    nticks: xValues.length,
                    tickangle: 0
                },
                yaxis: {title: 'Số lượng trả lại'}
            };

            // Delete Plot Data
            // const deleteMarkers = {
            //     x: lstCountMethodLine.data.map((point) => point.date),
            //     y: lstCountMethodLine.data.map((point) => point.totalDelete),
            //     mode: 'markers',
            //     type: 'scatter',
            //     name: 'Delete Markers',
            //     marker: {color: 'red', size: 6}
            // };

            const tongTienLines = {
                x: xValues,
                y: yTotalMoneyValues,
                mode: 'lines+markers+text',
                // type: 'scatter',
                name: 'Tổng tiền<br>Huỷ',
                line: {color: 'red', width: 2},
                connectgaps: false,
                text: yTotalMoneyValues.map((y) => formatNumber(y).toString()), // Convert Y values to strings for display
                textposition: 'top center', // Position text on top of the markers
                textfont: {
                    size: 10, // Adjust font size if needed
                    color: 'black' // Change text color if necessary
                }
            };

            // const deleteData = [deleteMarkers, deleteLines];
            const tongTienData = [tongTienLines];

            const tongTienLayout = {
                title: 'Biểu đồ Tổng tiền trả lại',
                showlegend: true,
                xaxis: {
                    title: 'Thời gian',
                    type: 'date',
                    tickformat:
                    displayByHMSFeeTraLai === 'month'
                            ? '%b<br>%Y'
                            : displayByHMSFeeTraLai === 'week'
                            ? 'Tuần %W<br>%Y'
                            : '%-d %b<br>%Y',
                    tickfont: {size: 12},
                    nticks: xValues.length,
                    tickangle: 0
                },
                yaxis: {title: 'Tổng tiền trả lại'},
                annotations: [
                    {
                        xref: 'paper', // Positions the annotation relative to the chart
                        yref: 'paper',
                        x: 1.05, // Position it slightly to the right of the chart
                        y: 1.25, // Align it near the top
                        text: '1M = 1 triệu VNĐ', // Annotation text
                        showarrow: false,
                        font: {
                            size: 12,
                            color: 'black'
                        },
                        align: 'right'
                    },
                    {
                        xref: 'paper', // Positions the annotation relative to the chart
                        yref: 'paper',
                        x: 1.05, // Position it slightly to the right of the chart
                        y: 1.15, // Align it near the top
                        text: '1B = 1 tỷ VNĐ', // Annotation text
                        showarrow: false,
                        font: {
                            size: 12,
                            color: 'black'
                        },
                        align: 'right'
                    }
                ]
            };

            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefSoLuongHMSFeeTraLai.current,
                soLuongTraLaiData,
                soLuongTraLaiLayout,
                config
            );

            // Render Delete Plot
            Plotly.newPlot(
                plotRefTongTienHMSFeeTraLai.current,
                tongTienData,
                tongTienLayout,
                config
            );

            // Plotly.animate(
            //     plotRefSoLuongCancel.current,
            //     {
            //         data: [{x: xValues, y: yCountCancelValues}],
            //         traces: [0],
            //         layout: {}
            //     },
            //     {
            //         transition: {
            //             duration: 500,
            //             easing: 'cubic-in-out'
            //         },
            //         frame: {
            //             duration: 500
            //         }
            //     }
            // );

            // animationGraph(plotRefSoLuongCancel.current, xValues, yCountCancelValues);
            // animationGraph(plotRefTongTienCancel.current, xValues, yTotalMoneyValues);
        } else {
            const config = {responsive: true};

            // Render Update Plot
            Plotly.newPlot(
                plotRefSoLuongHMSFeeTraLai.current,
                [],
                {title: 'Biểu đồ Số lượng trả lại'},
                config
            );

            // Render Delete Plot
            Plotly.newPlot(
                plotRefTongTienHMSFeeTraLai.current,
                [],
                {title: 'Biểu đồ Tổng tiền trả lại'},
                config
            );
        }
    }, [lstCountHMSFeeTraLai.data, displayByHMSFeeTraLai]);

    useEffect(() => {
        const handleResize = () => {
            if (plotRefSoLuongHMSFeeTraLai.current) {
                Plotly.Plots.resize(plotRefSoLuongHMSFeeTraLai.current);
            }
            if (plotRefTongTienHMSFeeTraLai.current) {
                Plotly.Plots.resize(plotRefTongTienHMSFeeTraLai.current);
            }
        };

        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
            if (plotRefSoLuongHMSFeeTraLai.current) {
                Plotly.purge(plotRefSoLuongHMSFeeTraLai.current);
            }
            if (plotRefTongTienHMSFeeTraLai.current) {
                Plotly.purge(plotRefTongTienHMSFeeTraLai.current);
            }
        };
    }, []);

    // end HMS Fee Tra lai

    // const animationGraph = (plotRef, xVals, yVals) => {
    //     Plotly.animate(
    //         plotRef,
    //         {
    //             data: [{x: xVals, y: yVals}],
    //             traces: [0],
    //             layout: {}
    //         },
    //         {
    //             transition: {
    //                 duration: 500,
    //                 easing: 'cubic-in-out'
    //             },
    //             frame: {
    //                 duration: 500
    //             }
    //         }
    //     );
    // };

    return (
        <div className="container-fluid">
            <div className="row" style={{marginBottom: '20px'}}>
                <div className="col-lg-4">
                </div>
            </div>
            <div className="row">
                <div
                    className="col-lg-3"
                    style={{paddingLeft: '50px', paddingRight: '50px'}}
                >
                    <SmallBox
                        count={
                            countReport &&
                            countReport.data &&
                            countReport.data.totalUpdate
                                ? countReport.data.totalUpdate.toLocaleString(
                                      'vi-VN'
                                  )
                                : 0
                        }
                        title="Số lượng Cập nhật bản ghi"
                        type="945A7C"
                        des={
                            <div className="row">
                                <div>
                                    Số lượng cập nhật ngày:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalUpdateNgay
                                        ? countReport.data.totalUpdateNgay.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng cập nhật tuần:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalUpdateTuan
                                        ? countReport.data.totalUpdateTuan.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng cập nhật tháng:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalUpdateThang
                                        ? countReport.data.totalUpdateThang.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                {/* <div>
                                    Số lượng cập nhật quý:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalUpdateQuy
                                        ? countReport.data.totalUpdateQuy.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng cập nhật 6 tháng:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalUpdate6Thang
                                        ? countReport.data.totalUpdate6Thang.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div> */}
                                <div>
                                    Số lượng cập nhật năm:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalUpdateNam
                                        ? countReport.data.totalUpdateNam.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                            </div>
                        }
                        navigateTo="/"
                    />
                </div>
                <div
                    className="col-lg-3"
                    style={{paddingLeft: '50px', paddingRight: '50px'}}
                >
                    <SmallBox
                        count={
                            countReport &&
                            countReport.data &&
                            countReport.data.totalDelete
                                ? countReport.data.totalDelete.toLocaleString(
                                      'vi-VN'
                                  )
                                : 0
                        }
                        title="Số lượng Xoá bản ghi"
                        type="9F96BB"
                        des={
                            <div className="row">
                                <div>
                                    Số lượng xoá ngày:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalDeleteNgay
                                        ? countReport.data.totalDeleteNgay.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng xoá tuần:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalDeleteTuan
                                        ? countReport.data.totalDeleteTuan.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng xoá tháng:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalDeleteThang
                                        ? countReport.data.totalDeleteThang.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                {/* <div>
                                    Số lượng xoá quý:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalDeleteQuy
                                        ? countReport.data.totalDeleteQuy.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng xoá 6 tháng:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalDelete6Thang
                                        ? countReport.data.totalDelete6Thang.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div> */}
                                <div>
                                    Số lượng xoá năm:{' '}
                                    {countReport &&
                                    countReport.data &&
                                    countReport.data.totalDeleteNam
                                        ? countReport.data.totalDeleteNam.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                            </div>
                        }
                        navigateTo="/"
                    />
                </div>
                <div
                    className="col-lg-3"
                    style={{paddingLeft: '50px', paddingRight: '50px'}}
                >
                    <SmallBox
                        count={
                            countCancelReport &&
                            countCancelReport.data &&
                            countCancelReport.data.totalCancel
                                ? countCancelReport.data.totalCancel.toLocaleString(
                                      'vi-VN'
                                  )
                                : 0
                        }
                        title="Số lượng Huỷ thanh toán"
                        type="C85959"
                        des={
                            <div className="row">
                                <div>
                                    Số lượng huỷ ngày:{' '}
                                    {countCancelReport &&
                                    countCancelReport.data &&
                                    countCancelReport.data.totalCancelNgay
                                        ? countCancelReport.data.totalCancelNgay.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng huỷ tuần:{' '}
                                    {countCancelReport &&
                                    countCancelReport.data &&
                                    countCancelReport.data.totalCancelTuan
                                        ? countCancelReport.data.totalCancelTuan.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng huỷ tháng:{' '}
                                    {countCancelReport &&
                                    countCancelReport.data &&
                                    countCancelReport.data.totalCancelThang
                                        ? countCancelReport.data.totalCancelThang.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                {/* <div>
                                    Số lượng huỷ quý:{' '}
                                    {countCancelReport &&
                                    countCancelReport.data &&
                                    countCancelReport.data.totalCancelQuy
                                        ? countCancelReport.data.totalCancelQuy.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng huỷ 6 tháng:{' '}
                                    {countCancelReport &&
                                    countCancelReport.data &&
                                    countCancelReport.data.totalCancel6Thang
                                        ? countCancelReport.data.totalCancel6Thang.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div> */}
                                <div>
                                    Số lượng huỷ năm:{' '}
                                    {countCancelReport &&
                                    countCancelReport.data &&
                                    countCancelReport.data.totalCancelNam
                                        ? countCancelReport.data.totalCancelNam.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                            </div>
                        }
                        navigateTo="/"
                    />
                </div>
                <div
                    className="col-lg-3"
                    style={{paddingLeft: '50px', paddingRight: '50px'}}
                >
                    <SmallBox
                        count={
                            countTraLaiReport &&
                            countTraLaiReport.data &&
                            countTraLaiReport.data.totalCancel
                                ? countTraLaiReport.data.totalCancel.toLocaleString(
                                      'vi-VN'
                                  )
                                : 0
                        }
                        title="Số lượng Trả lại thanh toán"
                        type="C85959"
                        des={
                            <div className="row">
                                <div>
                                    Số lượng trả lại ngày:{' '}
                                    {countTraLaiReport &&
                                    countTraLaiReport.data &&
                                    countTraLaiReport.data.totalCancelNgay
                                        ? countTraLaiReport.data.totalCancelNgay.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng trả lại tuần:{' '}
                                    {countTraLaiReport &&
                                    countTraLaiReport.data &&
                                    countTraLaiReport.data.totalCancelTuan
                                        ? countTraLaiReport.data.totalCancelTuan.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng trả lại tháng:{' '}
                                    {countTraLaiReport &&
                                    countTraLaiReport.data &&
                                    countTraLaiReport.data.totalCancelThang
                                        ? countTraLaiReport.data.totalCancelThang.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                {/* <div>
                                    Số lượng trả lại quý:{' '}
                                    {countTraLaiReport &&
                                    countTraLaiReport.data &&
                                    countTraLaiReport.data.totalCancelQuy
                                        ? countTraLaiReport.data.totalCancelQuy.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                                <div>
                                    Số lượng trả lại 6 tháng:{' '}
                                    {countTraLaiReport &&
                                    countTraLaiReport.data &&
                                    countTraLaiReport.data.totalCancel6Thang
                                        ? countTraLaiReport.data.totalCancel6Thang.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div> */}
                                <div>
                                    Số lượng trả lại năm:{' '}
                                    {countTraLaiReport &&
                                    countTraLaiReport.data &&
                                    countTraLaiReport.data.totalCancelNam
                                        ? countTraLaiReport.data.totalCancelNam.toLocaleString(
                                              'vi-VN'
                                          )
                                        : 0}
                                </div>
                            </div>
                        }
                        navigateTo="/"
                    />
                </div>
                {/* <div className="col-lg-3 col-6">
                    <SmallBox
                        count={countAllPost}
                        title="Số lượng cancel"
                        type="C85959"
                        des={
                            <>
                                <div>Lượng cancel ngày: {countAllPost}</div>
                                <div>Lượng cancel tuần: {countAllPost}</div>
                                <div>Lượng cancel tháng: {countAllPost}</div>
                                <div>Lượng cancel quý: {countAllPost}</div>
                                <div>Lượng cancel 6 tháng: {countAllPost}</div>
                                <div>Lượng cancel năm: {countAllPost}</div>
                            </>
                        }
                        navigateTo="/"
                    />
                </div> */}
            </div>
            {/* <div style={{marginBottom: '1rem'}} className="row">
                <div style={{height: chieucao}} className="col-lg-3 col-3">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Test Doughnut
                        </Card.Header>
                        <Card.Body>
                            <div className="col-md-12" style={{height: '100%'}}>
                                <div
                                    className="card-header p-2"
                                    style={{height: '100%'}}
                                >
                                    <Doughnut
                                        data={finalData}
                                        options={options}
                                    />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
                <div style={{height: chieucao}} className="col-lg-3 col-3">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Test Doughnut
                        </Card.Header>
                        <Card.Body>
                            <div className="col-md-12" style={{height: '100%'}}>
                                <div
                                    className="card-header p-2"
                                    style={{height: '100%'}}
                                >
                                    <Doughnut data={data} options={options} />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
                <div style={{height: chieucao}} className="col-lg-3 col-3">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Test Pie
                        </Card.Header>
                        <Card.Body>
                            <div className="col-md-12" style={{height: '100%'}}>
                                <div
                                    className="card-header p-2"
                                    style={{height: '100%'}}
                                >
                                    <Pie data={data} />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
                <div style={{height: chieucao}} className="col-lg-3 col-3">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Test Pie
                        </Card.Header>
                        <Card.Body>
                            <div className="col-md-12" style={{height: '100%'}}>
                                <div
                                    className="card-header p-2"
                                    style={{height: '100%'}}
                                >
                                    <Pie data={data} />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div> */}
            {/* <div style={{marginBottom: '1rem'}} className="row">
                <div id="baocaothongke" ref={refBaocao} className="col-lg-12">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Biểu đồ test
                        </Card.Header>
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefTest}
                                    style={{width: '100%'}}
                                ></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div> */}

            <div style={{marginBottom: '1rem'}} className="row">
                <div id="baocaothongke" ref={refBaocao} className="col-lg-12">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Biểu đồ cột Giám sát
                        </Card.Header>
                        <Card.Header className="row">
                            <div className="col-lg-6">
                                <DateRangePicker
                                    onApply={handleApplyGiamSat}
                                    onCancel={handleCancelGiamSat}
                                    // onEvent={handleEvent}
                                    initialSettings={{
                                        // autoUpdateInput: false,
                                        locale: {
                                            format: 'DD/MM/YYYY HH:mm',
                                            cancelLabel: 'Xóa',
                                            customRangeLabel: 'Tùy chọn',
                                            applyLabel: 'Chọn',
                                            monthNames: monthNames
                                        },
                                        linkedCalendars: false,
                                        showDropdowns: true,
                                        ranges: rangeDateReport,
                                        timePicker: true,
                                        timePicker24Hour: true
                                        // startDate: moment(
                                        //     dates.startDate
                                        // ).format('MM/DD/YYYY'),
                                        // endDate: moment(
                                        //     dates.endDate
                                        // ).format('MM/DD/YYYY'),
                                    }}
                                >
                                    <input
                                        onChange={(e) => {
                                            if (e.target.value.length === 0) {
                                                setDatesGiamSat({
                                                    startDate: null,
                                                    endDate: null
                                                });
                                            }
                                        }}
                                        defaultValue={`${moment(
                                            datesGiamSat.startDate
                                        ).format(
                                            'DD/MM/YYYY HH:mm'
                                        )} - ${moment(
                                            datesGiamSat.endDate
                                        ).format('DD/MM/YYYY HH:mm')}`}
                                        type="text"
                                        className="form-control"
                                        placeholder="Chọn khoảng thời gian"
                                    />
                                </DateRangePicker>
                            </div>
                            <div className="col-lg-6"></div>
                        </Card.Header>
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefNoiDungGiamSat}
                                    style={{width: '100%'}}
                                ></div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefLyDoGiamSat}
                                    style={{width: '100%'}}
                                ></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

            <div style={{marginBottom: '1rem'}} className="row">
                <div id="baocaothongke" ref={refBaocao} className="col-lg-12">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Số tiền chênh lệch và Top 10 Đơn vị đề nghị
                        </Card.Header>
                        <Card.Header className="row">
                            <div className="col-lg-6">
                                <DateRangePicker
                                    onApply={handleApplySoTienVaDonVi}
                                    onCancel={handleCancelSoTienVaDonVi}
                                    initialSettings={{
                                        locale: {
                                            format: 'DD/MM/YYYY HH:mm',
                                            cancelLabel: 'Xóa',
                                            customRangeLabel: 'Tùy chọn',
                                            applyLabel: 'Chọn',
                                            monthNames: monthNames
                                        },
                                        linkedCalendars: false,
                                        showDropdowns: true,
                                        ranges: rangeDateReport,
                                        timePicker: true,
                                        timePicker24Hour: true
                                    }}
                                >
                                    <input
                                        onChange={(e) => {
                                            if (e.target.value.length === 0) {
                                                setDatesSoTienVaDonVi({
                                                    startDate: null,
                                                    endDate: null
                                                });
                                            }
                                        }}
                                        defaultValue={`${moment(
                                            datesSoTienVaDonVi.startDate
                                        ).format(
                                            'DD/MM/YYYY HH:mm'
                                        )} - ${moment(
                                            datesSoTienVaDonVi.endDate
                                        ).format('DD/MM/YYYY HH:mm')}`}
                                        type="text"
                                        className="form-control"
                                        placeholder="Chọn khoảng thời gian"
                                    />
                                </DateRangePicker>
                            </div>
                            <div className="col-lg-6">
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="week"
                                        checked={
                                            displayBySoTienVaDonVi === 'week'
                                        }
                                        onChange={() =>
                                            setDisplayBySoTienVaDonVi('week')
                                        }
                                    />
                                    Theo tuần
                                </label>
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="month"
                                        checked={
                                            displayBySoTienVaDonVi === 'month'
                                        }
                                        onChange={() =>
                                            setDisplayBySoTienVaDonVi('month')
                                        }
                                    />
                                    Theo tháng
                                </label>
                            </div>
                        </Card.Header>
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefSoTienChenhLech}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefDonViDeNghi}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

            <div style={{marginBottom: '1rem'}} className="row">
                <div id="baocaothongke" ref={refBaocao} className="col-lg-12">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Biểu đồ đường Số lượng đề nghị
                        </Card.Header>
                        <Card.Header className="row">
                            <div className="col-lg-6">
                                <DateRangePicker
                                    onApply={handleApplyMethodLineSoLuongDeNghi}
                                    onCancel={
                                        handleCancelMethodLineSoLuongDeNghi
                                    }
                                    initialSettings={{
                                        // autoUpdateInput: false,
                                        locale: {
                                            format: 'DD/MM/YYYY HH:mm',
                                            cancelLabel: 'Xóa',
                                            customRangeLabel: 'Tùy chọn',
                                            applyLabel: 'Chọn',
                                            monthNames: monthNames
                                        },
                                        // autoApply: true,
                                        linkedCalendars: false,
                                        showDropdowns: true,
                                        ranges: rangeDateDashboardNotHaveDate,
                                        timePicker: true,
                                        timePicker24Hour: true
                                        // startDate: moment(
                                        //     datesMethodLineSoLuongDeNghi.startDate
                                        // ).format('DD/MM/YYYY HH:mm'),
                                        // endDate: moment(
                                        //     datesMethodLineSoLuongDeNghi.endDate
                                        // ).format('DD/MM/YYYY HH:mm')
                                    }}
                                >
                                    <input
                                        onChange={(e) => {
                                            if (e.target.value.length === 0) {
                                                setDatesMethodLineSoLuongDeNghi(
                                                    {
                                                        startDate: null,
                                                        endDate: null
                                                    }
                                                );
                                            }
                                        }}
                                        defaultValue={`${moment(
                                            datesMethodLineSoLuongDeNghi.startDate
                                        ).format(
                                            'DD/MM/YYYY HH:mm'
                                        )} - ${moment(
                                            datesMethodLineSoLuongDeNghi.endDate
                                        ).format('DD/MM/YYYY HH:mm')}`}
                                        type="text"
                                        className="form-control"
                                        placeholder="Chọn khoảng thời gian"
                                    />
                                </DateRangePicker>
                            </div>
                            <div className="col-lg-6">
                                {/* <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="date"
                                        checked={displayBy === 'date'}
                                        onChange={() => setDisplayBy('date')}
                                    />
                                    Theo ngày
                                </label> */}
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="week"
                                        checked={displayBy === 'week'}
                                        onChange={() => setDisplayBy('week')}
                                    />
                                    Theo tuần
                                </label>
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="month"
                                        checked={displayBy === 'month'}
                                        onChange={() => setDisplayBy('month')}
                                    />
                                    Theo tháng
                                </label>
                            </div>
                        </Card.Header>
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefSoLuongDeNghiGiamSatPhanMem}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    ref={
                                        plotRefSoLuongDeNghiGiamSatDuLieuBenhVien
                                    }
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

            <div style={{marginBottom: '1rem'}} className="row">
                <div id="baocaothongke" ref={refBaocao} className="col-lg-12">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Biểu đồ đường Chức năng Huỷ
                        </Card.Header>
                        <Card.Header className="row">
                            <div className="col-lg-6">
                                <DateRangePicker
                                    onApply={handleApplyMethodLineCancel}
                                    onCancel={handleCancelMethodLineCancel}
                                    // onEvent={handleEvent}
                                    initialSettings={{
                                        // autoUpdateInput: false,
                                        locale: {
                                            format: 'DD/MM/YYYY HH:mm',
                                            cancelLabel: 'Xóa',
                                            customRangeLabel: 'Tùy chọn',
                                            applyLabel: 'Chọn',
                                            monthNames: monthNames
                                        },
                                        linkedCalendars: false,
                                        showDropdowns: true,
                                        ranges: rangeDateDashboardNotHaveDate,
                                        timePicker: true,
                                        timePicker24Hour: true
                                        // startDate: moment(
                                        //     dates.startDate
                                        // ).format('MM/DD/YYYY'),
                                        // endDate: moment(
                                        //     dates.endDate
                                        // ).format('MM/DD/YYYY'),
                                    }}
                                >
                                    <input
                                        onChange={(e) => {
                                            if (e.target.value.length === 0) {
                                                setDatesMethodLineCancel({
                                                    startDate: null,
                                                    endDate: null
                                                });
                                            }
                                        }}
                                        defaultValue={`${moment(
                                            datesMethodLineCancel.startDate
                                        ).format(
                                            'DD/MM/YYYY HH:mm'
                                        )} - ${moment(
                                            datesMethodLineCancel.endDate
                                        ).format('DD/MM/YYYY HH:mm')}`}
                                        type="text"
                                        className="form-control"
                                        placeholder="Chọn khoảng thời gian"
                                    />
                                </DateRangePicker>
                            </div>
                            <div className="col-lg-6">
                                {/* <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="date"
                                        checked={displayByCancel === 'date'}
                                        onChange={() =>
                                            setDisplayByCancel('date')
                                        }
                                    />
                                    Theo ngày
                                </label> */}
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="week"
                                        checked={displayByCancel === 'week'}
                                        onChange={() =>
                                            setDisplayByCancel('week')
                                        }
                                    />
                                    Theo tuần
                                </label>
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="month"
                                        checked={displayByCancel === 'month'}
                                        onChange={() =>
                                            setDisplayByCancel('month')
                                        }
                                    />
                                    Theo tháng
                                </label>
                            </div>
                        </Card.Header>
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefSoLuongCancel}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefTongTienCancel}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

            <div style={{marginBottom: '1rem'}} className="row">
                <div id="baocaothongke" ref={refBaocao} className="col-lg-12">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Biểu đồ đường Chức năng trả lại
                        </Card.Header>
                        <Card.Header className="row">
                            <div className="col-lg-6">
                                <DateRangePicker
                                    onApply={handleApplyHMSFeeTraLai}
                                    onCancel={handleCancelHMSFeeTraLai}
                                    // onEvent={handleEvent}
                                    initialSettings={{
                                        // autoUpdateInput: false,
                                        locale: {
                                            format: 'DD/MM/YYYY HH:mm',
                                            cancelLabel: 'Xóa',
                                            customRangeLabel: 'Tùy chọn',
                                            applyLabel: 'Chọn',
                                            monthNames: monthNames
                                        },
                                        linkedCalendars: false,
                                        showDropdowns: true,
                                        ranges: rangeDateDashboardNotHaveDate,
                                        timePicker: true,
                                        timePicker24Hour: true
                                        // startDate: moment(
                                        //     dates.startDate
                                        // ).format('MM/DD/YYYY'),
                                        // endDate: moment(
                                        //     dates.endDate
                                        // ).format('MM/DD/YYYY'),
                                    }}
                                >
                                    <input
                                        onChange={(e) => {
                                            if (e.target.value.length === 0) {
                                                setDatesHMSFeeTraLai({
                                                    startDate: null,
                                                    endDate: null
                                                });
                                            }
                                        }}
                                        defaultValue={`${moment(
                                            datesHMSFeeTraLai.startDate
                                        ).format(
                                            'DD/MM/YYYY HH:mm'
                                        )} - ${moment(
                                            datesHMSFeeTraLai.endDate
                                        ).format('DD/MM/YYYY HH:mm')}`}
                                        type="text"
                                        className="form-control"
                                        placeholder="Chọn khoảng thời gian"
                                    />
                                </DateRangePicker>
                            </div>
                            <div className="col-lg-6">
                                {/* <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="date"
                                        checked={displayByCancel === 'date'}
                                        onChange={() =>
                                            setDisplayByCancel('date')
                                        }
                                    />
                                    Theo ngày
                                </label> */}
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="week"
                                        checked={displayByHMSFeeTraLai === 'week'}
                                        onChange={() =>
                                            setDisplayByHMSFeeTraLai('week')
                                        }
                                    />
                                    Theo tuần
                                </label>
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="month"
                                        checked={displayByHMSFeeTraLai === 'month'}
                                        onChange={() =>
                                            setDisplayByHMSFeeTraLai('month')
                                        }
                                    />
                                    Theo tháng
                                </label>
                            </div>
                        </Card.Header>
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefSoLuongHMSFeeTraLai}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefTongTienHMSFeeTraLai}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

            {/* <div style={{marginBottom: '1rem'}} className="row">
                <div id="baocaothongke" ref={refBaocao} className="col-lg-12">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Biểu đồ đường Chức năng Bảo hiểm
                        </Card.Header>
                        <Card.Header className="row">
                            <div className="col-lg-6">
                                <DateRangePicker
                                    onApply={handleApplyLineBaoHiem}
                                    onCancel={handleCancelLineBaoHiem}
                                    initialSettings={{
                                        locale: {
                                            format: 'DD/MM/YYYY HH:mm',
                                            cancelLabel: 'Xóa',
                                            customRangeLabel: 'Tùy chọn',
                                            applyLabel: 'Chọn',
                                            monthNames: monthNames
                                        },
                                        linkedCalendars: false,
                                        showDropdowns: true,
                                        ranges: rangeDateReport,
                                        timePicker: true,
                                        timePicker24Hour: true
                                    }}
                                >
                                    <input
                                        onChange={(e) => {
                                            if (e.target.value.length === 0) {
                                                setDatesLineBaoHiem({
                                                    startDate: null,
                                                    endDate: null
                                                });
                                            }
                                        }}
                                        defaultValue={`${moment(
                                            datesLineBaoHiem.startDate
                                        ).format(
                                            'DD/MM/YYYY HH:mm'
                                        )} - ${moment(
                                            datesLineBaoHiem.endDate
                                        ).format('DD/MM/YYYY HH:mm')}`}
                                        type="text"
                                        className="form-control"
                                        placeholder="Chọn khoảng thời gian"
                                    />
                                </DateRangePicker>
                            </div>
                            <div className="col-lg-6">
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="week"
                                        checked={displayByBaoHiem === 'week'}
                                        onChange={() =>
                                            setDisplayByBaoHiem('week')
                                        }
                                    />
                                    Theo tuần
                                </label>
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="month"
                                        checked={displayByBaoHiem === 'month'}
                                        onChange={() =>
                                            setDisplayByBaoHiem('month')
                                        }
                                    />
                                    Theo tháng
                                </label>
                            </div>
                        </Card.Header>
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefSoLuongBaoHiem}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefTongTienBaoHiem}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div> */}

            <div style={{marginBottom: '1rem'}} className="row">
                <div id="baocaothongke" ref={refBaocao} className="col-lg-12">
                    <Card style={{height: '100%'}}>
                        <Card.Header style={{fontSize: 25}}>
                            Biểu đồ đường Chức năng
                        </Card.Header>
                        <Card.Header className="row">
                            <div className="col-lg-6">
                                <DateRangePicker
                                    onApply={handleApplyMethodLine}
                                    onCancel={handleCancelMethodLine}
                                    // onEvent={handleEvent}
                                    initialSettings={{
                                        // autoUpdateInput: false,
                                        locale: {
                                            format: 'DD/MM/YYYY HH:mm',
                                            cancelLabel: 'Xóa',
                                            customRangeLabel: 'Tùy chọn',
                                            applyLabel: 'Chọn',
                                            monthNames: monthNames
                                        },
                                        linkedCalendars: false,
                                        showDropdowns: true,
                                        ranges: rangeDateReport,
                                        timePicker: true,
                                        timePicker24Hour: true
                                        // startDate: moment(
                                        //     dates.startDate
                                        // ).format('MM/DD/YYYY'),
                                        // endDate: moment(
                                        //     dates.endDate
                                        // ).format('MM/DD/YYYY'),
                                    }}
                                >
                                    <input
                                        onChange={(e) => {
                                            if (e.target.value.length === 0) {
                                                setDatesMethodLine({
                                                    startDate: null,
                                                    endDate: null
                                                });
                                            }
                                        }}
                                        defaultValue={`${moment(
                                            datesMethodLine.startDate
                                        ).format(
                                            'DD/MM/YYYY HH:mm'
                                        )} - ${moment(
                                            datesMethodLine.endDate
                                        ).format('DD/MM/YYYY HH:mm')}`}
                                        type="text"
                                        className="form-control"
                                        placeholder="Chọn khoảng thời gian"
                                    />
                                </DateRangePicker>
                            </div>
                            <div className="col-lg-6">
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="date"
                                        checked={displayByMethod === 'date'}
                                        onChange={() =>
                                            setDisplayByMethod('date')
                                        }
                                    />
                                    Theo ngày
                                </label>
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="week"
                                        checked={displayByMethod === 'week'}
                                        onChange={() =>
                                            setDisplayByMethod('week')
                                        }
                                    />
                                    Theo tuần
                                </label>
                                <label style={{marginLeft: '20px'}}>
                                    <input
                                        type="radio"
                                        value="month"
                                        checked={displayByMethod === 'month'}
                                        onChange={() =>
                                            setDisplayByMethod('month')
                                        }
                                    />
                                    Theo tháng
                                </label>
                            </div>
                        </Card.Header>
                        <div className="row">
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefUpdate}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    ref={plotRefDelete}
                                    style={{width: '100%', height: '400px'}}
                                ></div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>

            <div style={{marginBottom: '1rem'}} className="row">
                <div style={{height: '100%'}} className="col-lg-12">
                    <Card>
                        <Card.Header style={{fontSize: 25}}>
                            Tỉ lệ Chức năng và Giám sát theo thời gian
                        </Card.Header>
                        <Card.Header>
                            <DateRangePicker
                                onApply={handleApplyMethodDonut}
                                onCancel={handleCancelMethodDonut}
                                // onEvent={handleEvent}
                                initialSettings={{
                                    // autoUpdateInput: false,
                                    locale: {
                                        format: 'DD/MM/YYYY HH:mm',
                                        cancelLabel: 'Xóa',
                                        customRangeLabel: 'Tùy chọn',
                                        applyLabel: 'Chọn',
                                        monthNames: monthNames
                                    },
                                    linkedCalendars: false,
                                    showDropdowns: true,
                                    ranges: rangeDateReport,
                                    timePicker: true,
                                    timePicker24Hour: true
                                    // startDate: moment(
                                    //     dates.startDate
                                    // ).format('MM/DD/YYYY'),
                                    // endDate: moment(
                                    //     dates.endDate
                                    // ).format('MM/DD/YYYY'),
                                }}
                            >
                                <input
                                    onChange={(e) => {
                                        if (e.target.value.length === 0) {
                                            setDatesMethodDonut({
                                                startDate: null,
                                                endDate: null
                                            });
                                        }
                                    }}
                                    defaultValue={`${moment(
                                        datesMethodDonut.startDate
                                    ).format('DD/MM/YYYY HH:mm')} - ${moment(
                                        datesMethodDonut.endDate
                                    ).format('DD/MM/YYYY HH:mm')}`}
                                    type="text"
                                    className="form-control"
                                    placeholder="Chọn khoảng thời gian"
                                />
                            </DateRangePicker>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div
                                        ref={plotRef}
                                        style={{width: '100%'}}
                                    ></div>
                                </div>
                                <div className="col-lg-4">
                                    <div
                                        ref={plotRefNoiDungDonut}
                                        style={{width: '100%'}}
                                    ></div>
                                </div>
                                <div className="col-lg-4">
                                    <div
                                        ref={plotRefLyDoDonut}
                                        style={{width: '100%'}}
                                    ></div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
